module.exports=`
<body class="t-body" style="margin: 0px;">
<div id="allrecords" data-tilda-export="yes" class="t-records t-records_animated t-records_visible"
     data-hook="blocks-collection-content-node" data-tilda-project-id="2584819" data-tilda-page-id="23325595"
     data-tilda-page-alias="agile-ecosystem" data-tilda-formskey="7d8d153e3a87fa8a72eae98d3bb8118c"
     data-tilda-lazy="yes" data-tilda-page-headcode="yes">
  <div id="rec376559351" class="r t-rec" style="background-color:#ffffff; " data-animationappear="off"
       data-record-type="997" data-bg-color="#ffffff">
    <div class="t-cover" id="recorddiv376559351" bgimgfield="img"
         style="height: 720px; background-image: url(/langings/agileEcosystem/images/tild3163-6432-4636-b436-653839633737__bg.svg);">
      <div class="t-cover__carrier loaded" id="coverCarry376559351" data-content-cover-id="376559351"
           data-content-cover-bg="/langings/agileEcosystem/images/tild3163-6432-4636-b436-653839633737__bg.svg"
           data-content-cover-height="50vh" data-content-cover-parallax="dynamic"
           style="height: 720px; background-attachment: scroll; background-position: center top; top: 0px; background-image: url(/langings/agileEcosystem/images/tild3163-6432-4636-b436-653839633737__bg.svg);"
           src=""></div>
      <div class="t-cover__filter"
           style="height: 720px; background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));"></div>
      <div class="t997">
        <div class="t-container">
          <div class="t-cover__wrapper" style="height: 720px;">
            <div class="t997__wrapper">
              <div class="t997__inner" data-hook-content="covercontent">
                <div class="t997__header-wrapper">
                  <div class="t-section__topwrapper t-col t-col_8 t-align_left t-valign_middle">
                    <div class="t997__title t-title t-title_md" field="title">
                      <div style="font-size:72px;color:#000000;" data-customstyle="yes">How We<br>Redefined Agile</div>
                    </div>
                    <div class="t997__descr t-descr t-descr_lg" field="descr">
                      <div style="color:#000000;" data-customstyle="yes">Scrum tools have limited functionality, are
                        challenging to use, and have overwhelming UI. But we solved it.
                      </div>
                    </div>
                    <div class="t997__buttons">
                      <div class="t997__btn-wrapper"><a href="https://chpokify.com/sign-up" target=""
                                                        class="t997__btn t-btn "
                                                        style="color:#ffffff;background-color:#9147ff;border-radius:30px; -moz-border-radius:30px; -webkit-border-radius:30px;">Start Free</a></div>
                    </div>
                  </div>
                </div>
                <div class="t997__cards-wrapper"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec376657450" class="r t-rec t-rec_pt_90 t-rec_pb_0"
       style="padding-top:90px;padding-bottom:0px;background-color:#332624; " data-record-type="255"
       data-bg-color="#332624" data-animationappear="off">
    <div class="t225">
      <div class="t-container t-align_center">
        <div class="t-col t-col_10 t-prefix_1">
          <div class="t225__uptitle t-uptitle t-uptitle_sm" field="subtitle"
               style="color:#ffffff;text-transform:uppercase;">Kanban → Poker → Retro<br></div>
          <div class="t225__title t-title t-title_md" field="title" style="color:#ffffff;">Work seamlessly within<br>the
            Chpokify ecosystem
          </div>
          <div class="t225__descr t-descr t-descr_xxl" field="descr" style="color:#ffffff;">Plan your work and
            prioritize in Kanban. Estimate tasks in Poker.<br>Find out how the job went with Retro. On all platforms.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec383465167" class="r t-rec t-rec_pt_30 t-rec_pb_0"
       style="padding-top:30px;padding-bottom:0px;background-color:#332624; " data-record-type="223"
       data-bg-color="#332624" data-animationappear="off">
    <div class="t195">
      <div class="t-container">
        <div class="t-col t-col_3 ">
          <div class="t195__text t-text t-text_md" style="color:#ffffff;padding-top:160px;" field="text">
            <div style="line-height:32px;" data-customstyle="yes"><strong><span data-redactor-tag="span"
                                                                                style="font-size: 30px;">Chpokify/ Retro</span></strong><br>Collaborate
              with your team in a <strong><span data-redactor-tag="span" style="color: rgb(255, 223, 12);">stress-free way</span></strong>
              and move work forward.<br><br><a href="https://chpokify.com/sign-up"
                                               style="color:#ffffff !important;text-decoration: none;border-bottom: 1px solid #ffffff;box-shadow: inset 0px -0px 0px 0px #ffffff;-webkit-box-shadow: inset 0px -0px 0px 0px #ffffff;-moz-box-shadow: inset 0px -0px 0px 0px #ffffff;">Try
                Retro →</a><u><strong data-redactor-tag="strong"></strong></u>
              <div style="line-height:32px;" data-customstyle="yes"></div>
            </div>
          </div>
        </div>
        <div class="t-col t-col_9 t195__imgsection" itemscope="" itemtype="http://schema.org/ImageObject">
          <meta itemprop="image" content="/langings/agileEcosystem/images/tild3833-3430-4538-b034-356561303139__frame_578.svg">
          <img class="t195__img t-img loading" data-tu-max-width="1200" data-tu-max-height="1200"
               src="/langings/agileEcosystem/images/tild3833-3430-4538-b034-356561303139__frame_578.svg"
               imgfield="img"><br>
          <div class="t195__sectitle t-descr" style="color:#ffffff;" field="imgtitle" itemprop="name"></div>
          <div class="t195__secdescr t-descr" style="color:#ffffff;" field="imgdescr" itemprop="description"></div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec383465698" class="r t-rec t-rec_pt_0 t-rec_pb_0"
       style="padding-top:0px;padding-bottom:0px;background-color:#332624; " data-record-type="223"
       data-bg-color="#332624" data-animationappear="off">
    <div class="t195">
      <div class="t-container">
        <div class="t-col t-col_3 ">
          <div class="t195__text t-text t-text_md" style="color:#ffffff;padding-top:160px;" field="text">
            <div style="line-height:32px;" data-customstyle="yes"><strong><span data-redactor-tag="span"
                                                                                style="font-size: 30px;">Chpokify/ Poker</span></strong><br>Get
              <strong><span data-redactor-tag="span"
                            style="color: rgb(255, 223, 12);">accurate estimations</span></strong> from your agile
              teams. Play on desktop or mobile.<br><br><a href="https://chpokify.com/sign-up"
                                                          style="color:#ffffff !important;text-decoration: none;border-bottom: 1px solid #ffffff;box-shadow: inset 0px -0px 0px 0px #ffffff;-webkit-box-shadow: inset 0px -0px 0px 0px #ffffff;-moz-box-shadow: inset 0px -0px 0px 0px #ffffff;">Try
                Poker →</a><u><strong data-redactor-tag="strong"></strong></u>
              <div style="line-height:32px;" data-customstyle="yes"></div>
            </div>
          </div>
        </div>
        <div class="t-col t-col_9 t195__imgsection" itemscope="" itemtype="http://schema.org/ImageObject">
          <meta itemprop="image" content="/langings/agileEcosystem/images/tild6435-3666-4637-a162-613234363734__frame_576.svg">
          <img class="t195__img t-img loading" data-tu-max-width="1200" data-tu-max-height="1200"
               src="/langings/agileEcosystem/images/tild6435-3666-4637-a162-613234363734__frame_576.svg"
               imgfield="img"><br>
          <div class="t195__sectitle t-descr" style="color:#ffffff;" field="imgtitle" itemprop="name"></div>
          <div class="t195__secdescr t-descr" style="color:#ffffff;" field="imgdescr" itemprop="description"></div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec383458972" class="r t-rec t-rec_pt_0 t-rec_pb_0"
       style="padding-top:0px;padding-bottom:0px;background-color:#332624; " data-record-type="223"
       data-bg-color="#332624" data-animationappear="off">
    <div class="t195">
      <div class="t-container">
        <div class="t-col t-col_3 ">
          <div class="t195__text t-text t-text_md" style="color:#ffffff;padding-top:160px;" field="text">
            <div style="line-height:32px;" data-customstyle="yes"><strong><span data-redactor-tag="span"
                                                                                style="font-size: 30px;">Chpokify/ Kanban</span></strong><br>Plan
              projects, stay on track, and <strong><span data-redactor-tag="span" style="color: rgb(255, 223, 12);">deliver on time</span></strong>
              without overworking your team.<br><br><a href="https://chpokify.com/sign-up"
                                                       style="color:#ffffff !important;text-decoration: none;border-bottom: 1px solid #ffffff;box-shadow: inset 0px -0px 0px 0px #ffffff;-webkit-box-shadow: inset 0px -0px 0px 0px #ffffff;-moz-box-shadow: inset 0px -0px 0px 0px #ffffff;">Try
                Kanban →</a>
              <div style="line-height:32px;" data-customstyle="yes"></div>
            </div>
          </div>
        </div>
        <div class="t-col t-col_9 t195__imgsection" itemscope="" itemtype="http://schema.org/ImageObject">
          <meta itemprop="image" content="/langings/agileEcosystem/images/tild6263-3365-4633-a639-663332313664__frame_577.svg">
          <img class="t195__img t-img" data-tu-max-width="1200" data-tu-max-height="1200"
               src="/langings/agileEcosystem/images/tild6263-3365-4633-a639-663332313664__frame_577.svg"
               imgfield="img"><br>
          <div class="t195__sectitle t-descr" style="color:#ffffff;" field="imgtitle" itemprop="name"></div>
          <div class="t195__secdescr t-descr" style="color:#ffffff;" field="imgdescr" itemprop="description"></div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec411266622" class="r t-rec" style="background-color:#ffffff; " data-record-type="396"
       data-bg-color="#ffffff" data-animationappear="off">
    <style>#rec411266622 .t396__artboard {
      height: 580px;
      background-color: #fff;
    }

    #rec411266622 .t396__filter {
      height: 580px;
    }

    #rec411266622 .t396__carrier {
      height: 580px;
      background-position: center center;
      background-attachment: scroll;
      background-size: cover;
      background-repeat: no-repeat;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .t396__artboard {
        height: 580px;
      }

      #rec411266622 .t396__filter {
        height: 580px;
      }

      #rec411266622 .t396__carrier {
        height: 580px;
        background-attachment: scroll;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .t396__artboard {
        height: 522px;
      }

      #rec411266622 .t396__filter {
        height: 522px;
      }

      #rec411266622 .t396__carrier {
        height: 522px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .t396__artboard {
        height: 1040px;
      }

      #rec411266622 .t396__filter {
        height: 1040px;
      }

      #rec411266622 .t396__carrier {
        height: 1040px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .t396__artboard {
        height: 1040px;
      }

      #rec411266622 .t396__filter {
        height: 1040px;
      }

      #rec411266622 .t396__carrier {
        height: 1040px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1470210011265"] {
      color: #000000;
      text-align: center;
      z-index: 3;
      top: 179px;
      left: calc(50% - 600px + 220px);
      width: 760px;
    }

    #rec411266622 .tn-elem[data-elem-id="1470210011265"] .tn-atom {
      color: #000000;
      font-size: 16px;
      font-family: 'Arial', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      letter-spacing: 2.5px;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1470210011265"] {
        top: 179px;
        left: calc(50% - 480px + 170px);
        width: 620px;
      }

      #rec411266622 .tn-elem[data-elem-id="1470210011265"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1470210011265"] {
        top: 180px;
        left: calc(50% - 320px + 20px);
        width: 600px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1470210011265"] {
        top: 179px;
        left: calc(50% - 240px + 11px);
        width: 460px;
      }

      #rec411266622 .tn-elem[data-elem-id="1470210011265"] .tn-atom {
        font-size: 12px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1470210011265"] {
        top: 179px;
        left: calc(50% - 160px + 11px);
        width: 300px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1635534621515"] {
      z-index: 2;
      top: 0px;
      left: calc(50% - 600px + 0px);
      width: 50%;
      height: 580px;
    }

    #rec411266622 .tn-elem[data-elem-id="1635534621515"] .tn-atom {
      background-color: #fff;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1635534621515"] {
        top: 0px;
        left: calc(50% - 480px + 0px);
        width: 50%;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1635534621515"] {
        top: 0px;
        left: calc(50% - 320px + 0px);
        width: 50%;
        height: 522px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1635534621515"] {
        top: 0px;
        left: calc(50% - 240px + 0px);
        width: 100%;
        height: 50px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1635534621515"] {
        top: 0px;
        left: calc(50% - 160px + 0px);
        width: 100%;
        height: 50px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546079516"] {
      z-index: 52;
      top: 455px;
      left: calc(50% - 600px + 79px);
      width: 400px;
      height: 2px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546079516"] .tn-atom {
      background-color: #cccccc;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546079516"] {
        top: 448px;
        left: calc(50% - 480px + 60px);
        width: 350px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546079516"] {
        top: 406px;
        left: calc(50% - 320px + 0px);
        width: 50px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546079516"] {
        top: 412px;
        left: calc(50% - 240px + 10px);
        width: 460px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546079516"] {
        top: 397px;
        left: calc(50% - 160px + 10px);
        width: 300px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546327613"] {
      z-index: 53;
      top: 455px;
      left: calc(50% - 600px + 721px);
      width: 400px;
      height: 2px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546327613"] .tn-atom {
      background-color: #8651f6;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327613"] {
        top: 448px;
        left: calc(50% - 480px + 550px);
        width: 350px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327613"] {
        top: 406px;
        left: calc(50% - 320px + 320px);
        width: 50px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327613"] {
        top: 930px;
        left: calc(50% - 240px + 10px);
        width: 460px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327613"] {
        top: 938px;
        left: calc(50% - 160px + 10px);
        width: 300px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1635617609860"] {
      z-index: 1;
      top: 0px;
      left: calc(50% - 600px + 600px);
      width: 50%;
      height: 580px;
    }

    #rec411266622 .tn-elem[data-elem-id="1635617609860"] .tn-atom {
      background-color: #f5f0ff;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1635617609860"] {
        top: 0px;
        left: calc(50% - 480px + 480px);
        width: 50%;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1635617609860"] {
        top: 0px;
        left: calc(50% - 320px + 320px);
        width: 50%;
        height: 522px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1635617609860"] {
        top: 533px;
        left: calc(50% - 240px + 0px);
        width: 100%;
        height: 50px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1635617609860"] {
        top: 520px;
        left: calc(50% - 160px + 0px);
        width: 100%;
        height: 50px;
      }

      #rec411266622 .tn-elem[data-elem-id="1635617609860"] .tn-atom {
        background-color: #f5f0ff;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546182270"] {
      color: #000000;
      z-index: 6;
      top: 493px;
      left: calc(50% - 600px + 192px);
      width: 187px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546182270"] .tn-atom {
      color: #000000;
      font-size: 14px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546182270"] {
        top: 486px;
        left: calc(50% - 480px + 151px);
        width: 185px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546182270"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546182270"] {
        top: 436px;
        left: calc(50% - 320px + 96px);
        width: 209px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546182270"] {
        top: 448px;
        left: calc(50% - 240px + 136px);
        width: 191px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546182270"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546182270"] {
        top: 425px;
        left: calc(50% - 160px + 114px);
        width: 147px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546133307"] {
      color: #000000;
      z-index: 5;
      top: 483px;
      left: calc(50% - 600px + 80px);
      width: 87px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546133307"] .tn-atom {
      color: #000000;
      font-size: 40px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546133307"] {
        top: 482px;
        left: calc(50% - 480px + 60px);
        width: 276px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546133307"] .tn-atom {
        font-size: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546133307"] {
        top: 432px;
        left: calc(50% - 320px + 11px);
        width: 69px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546133307"] {
        top: 438px;
        left: calc(50% - 240px + 32px);
        width: 62px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546133307"] .tn-atom {
        font-size: 40px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546133307"] {
        top: 415px;
        left: calc(50% - 160px + 10px);
        width: 96px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546327618"] {
      color: #000000;
      z-index: 8;
      top: 493px;
      left: calc(50% - 600px + 811px);
      width: 268px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546327618"] .tn-atom {
      color: #000000;
      font-size: 14px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327618"] {
        top: 486px;
        left: calc(50% - 480px + 622px);
        width: 212px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546327618"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327618"] {
        top: 436px;
        left: calc(50% - 320px + 431px);
        width: 209px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327618"] {
        top: 966px;
        left: calc(50% - 240px + 112px);
        width: 191px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546327618"] .tn-atom {
        font-size: 14px;
        opacity: 1;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327618"] {
        top: 966px;
        left: calc(50% - 160px + 90px);
        width: 190px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546327621"] {
      color: #000000;
      z-index: 7;
      top: 483px;
      left: calc(50% - 600px + 722px);
      width: 73px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546327621"] .tn-atom {
      color: #000000;
      font-size: 40px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327621"] {
        top: 482px;
        left: calc(50% - 480px + 550px);
        width: 72px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546327621"] .tn-atom {
        font-size: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327621"] {
        top: 432px;
        left: calc(50% - 320px + 362px);
        width: 69px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327621"] {
        top: 956px;
        left: calc(50% - 240px + 32px);
        width: 52px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546327621"] .tn-atom {
        font-size: 40px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546327621"] {
        top: 956px;
        left: calc(50% - 160px + 10px);
        width: 72px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546554805"] {
      z-index: 54;
      top: 226px;
      left: calc(50% - 600px + 560px);
      width: 80px;
      height: 80px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546554805"] .tn-atom {
      border-radius: 3000px;
      background-color: #000000;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546554805"] {
        top: 246px;
        left: calc(50% - 480px + 448px);
        width: 64px;
        height: 64px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546554805"] {
        top: 250px;
        left: calc(50% - 320px + 296px);
        width: 48px;
        height: 48px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546554805"] {
        top: 509px;
        left: calc(50% - 240px + 216px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546554805"] {
        top: 496px;
        left: calc(50% - 160px + 136px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638546609403"] {
      color: #ffffff;
      text-align: center;
      z-index: 55;
      top: 236px;
      left: calc(50% - 600px + 560px);
      width: 80px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638546609403"] .tn-atom {
      color: #ffffff;
      font-size: 36px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638546609403"] {
        top: 260px;
        left: calc(50% - 480px + 448px);
        width: 64px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546609403"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638546609403"] {
        top: 255px;
        left: calc(50% - 320px + 300px);
        width: 40px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638546609403"] {
        top: 510px;
        left: calc(50% - 240px + 220px);
        width: 40px;
      }

      #rec411266622 .tn-elem[data-elem-id="1638546609403"] .tn-atom {
        font-size: 28px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638546609403"] {
        top: 497px;
        left: calc(50% - 160px + 125px);
        width: 70px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644400100958"] {
      color: #000000;
      z-index: 12;
      top: 279px;
      left: calc(50% - 600px + 760px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644400100958"] .tn-atom {
      color: #000000;
      font-size: 18px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.45;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100958"] {
        top: 297px;
        left: calc(50% - 480px + 589px);
        width: 299px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100958"] .tn-atom {
        font-size: 18px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100958"] {
        top: 268px;
        left: calc(50% - 320px + 393px);
        width: 235px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100958"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100958"] {
        top: 779px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100958"] .tn-atom {
        font-size: 18px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100958"] {
        top: 802px;
        left: calc(50% - 160px + 49px);
        width: 260px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100958"] {
        text-align: left;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100958"] .tn-atom {
        font-size: 14px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644400100961"] {
      color: #000000;
      z-index: 13;
      top: 246px;
      left: calc(50% - 600px + 760px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644400100961"] .tn-atom {
      color: #000000;
      font-size: 24px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.4;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100961"] {
        top: 262px;
        left: calc(50% - 480px + 589px);
        width: 299px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100961"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100961"] {
        top: 234px;
        left: calc(50% - 320px + 393px);
        width: 235px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100961"] {
        top: 747px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100961"] .tn-atom {
        font-size: 22px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100961"] {
        top: 770px;
        left: calc(50% - 160px + 49px);
        width: 260px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400100961"] {
        text-align: left;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644400100964"] {
      z-index: 14;
      top: 253px;
      left: calc(50% - 600px + 721px);
      width: 23px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644400100964"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100964"] {
        top: 267px;
        left: calc(50% - 480px + 550px);
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100964"] {
        top: 240px;
        left: calc(50% - 320px + 362px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100964"] {
        top: 752px;
        left: calc(50% - 240px + 49px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644400100964"] {
        top: 775px;
        left: calc(50% - 160px + 10px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644400207455"] {
      color: #000000;
      z-index: 18;
      top: 180px;
      left: calc(50% - 600px + 760px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644400207455"] .tn-atom {
      color: #000000;
      font-size: 18px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.45;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207455"] {
        top: 204px;
        left: calc(50% - 480px + 589px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207455"] .tn-atom {
        font-size: 18px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207455"] {
        top: 182px;
        left: calc(50% - 320px + 393px);
        width: 235px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207455"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207455"] {
        top: 689px;
        left: calc(50% - 240px + 88px);
        width: 360px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207455"] .tn-atom {
        font-size: 18px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207455"] {
        top: 718px;
        left: calc(50% - 160px + 49px);
        width: 260px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207455"] {
        text-align: left;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207455"] .tn-atom {
        font-size: 14px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644400207459"] {
      color: #000000;
      z-index: 19;
      top: 147px;
      left: calc(50% - 600px + 760px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644400207459"] .tn-atom {
      color: #000000;
      font-size: 24px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.4;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207459"] {
        top: 169px;
        left: calc(50% - 480px + 589px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207459"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207459"] {
        top: 148px;
        left: calc(50% - 320px + 393px);
        width: 235px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207459"] {
        top: 657px;
        left: calc(50% - 240px + 88px);
        width: 360px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207459"] .tn-atom {
        font-size: 22px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207459"] {
        top: 686px;
        left: calc(50% - 160px + 49px);
        width: 260px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644400207459"] {
        text-align: left;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644400207462"] {
      z-index: 20;
      top: 154px;
      left: calc(50% - 600px + 721px);
      width: 23px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644400207462"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207462"] {
        top: 174px;
        left: calc(50% - 480px + 550px);
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207462"] {
        top: 154px;
        left: calc(50% - 320px + 362px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207462"] {
        top: 662px;
        left: calc(50% - 240px + 49px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644400207462"] {
        top: 691px;
        left: calc(50% - 160px + 10px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644402283973"] {
      color: #000000;
      z-index: 27;
      top: 181px;
      left: calc(50% - 600px + 137px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644402283973"] .tn-atom {
      color: #000000;
      font-size: 18px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.45;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283973"] {
        top: 203px;
        left: calc(50% - 480px + 108px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283973"] .tn-atom {
        font-size: 18px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283973"] {
        top: 268px;
        left: calc(50% - 320px + 51px);
        width: 226px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283973"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283973"] {
        top: 171px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283973"] .tn-atom {
        font-size: 18px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283973"] {
        top: 174px;
        left: calc(50% - 160px + 68px);
        width: 200px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283973"] {
        text-align: left;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283973"] .tn-atom {
        font-size: 14px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644402283976"] {
      color: #000000;
      z-index: 21;
      top: 147px;
      left: calc(50% - 600px + 137px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644402283976"] .tn-atom {
      color: #000000;
      font-size: 24px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.4;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283976"] {
        top: 169px;
        left: calc(50% - 480px + 108px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283976"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283976"] {
        top: 234px;
        left: calc(50% - 320px + 51px);
        width: 226px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283976"] {
        top: 139px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283976"] .tn-atom {
        font-size: 22px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644402283976"] {
        top: 142px;
        left: calc(50% - 160px + 68px);
        width: 200px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402283976"] {
        text-align: left;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638544950148"] {
      z-index: 24;
      top: 147px;
      left: calc(50% - 600px + 81px);
      width: 40px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638544950148"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638544950148"] {
        top: 180px;
        left: calc(50% - 480px + 60px);
        width: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638544950148"] {
        top: 237px;
        left: calc(50% - 320px + 11px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638544950148"] {
        top: 144px;
        left: calc(50% - 240px + 32px);
        width: 40px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638544950148"] {
        top: 142px;
        left: calc(50% - 160px + 12px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644402526773"] {
      color: #000000;
      z-index: 33;
      top: 276px;
      left: calc(50% - 600px + 137px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644402526773"] .tn-atom {
      color: #000000;
      font-size: 18px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.45;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526773"] {
        top: 296px;
        left: calc(50% - 480px + 108px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526773"] .tn-atom {
        font-size: 18px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526773"] {
        top: 182px;
        left: calc(50% - 320px + 51px);
        width: 226px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526773"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526773"] {
        top: 261px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526773"] .tn-atom {
        font-size: 18px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526773"] {
        top: 258px;
        left: calc(50% - 160px + 68px);
        width: 200px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526773"] {
        text-align: left;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526773"] .tn-atom {
        font-size: 14px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644402526777"] {
      color: #000000;
      z-index: 30;
      top: 242px;
      left: calc(50% - 600px + 137px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644402526777"] .tn-atom {
      color: #000000;
      font-size: 24px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.4;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526777"] {
        top: 262px;
        left: calc(50% - 480px + 108px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526777"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526777"] {
        top: 148px;
        left: calc(50% - 320px + 51px);
        width: 226px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526777"] {
        top: 229px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526777"] .tn-atom {
        font-size: 22px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644402526777"] {
        top: 226px;
        left: calc(50% - 160px + 68px);
        width: 200px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402526777"] {
        text-align: left;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638545244697"] {
      z-index: 36;
      top: 242px;
      left: calc(50% - 600px + 81px);
      width: 40px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638545244697"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638545244697"] {
        top: 273px;
        left: calc(50% - 480px + 60px);
        width: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638545244697"] {
        top: 158px;
        left: calc(50% - 320px + 11px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638545244697"] {
        top: 239px;
        left: calc(50% - 240px + 32px);
        width: 40px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638545244697"] {
        top: 226px;
        left: calc(50% - 160px + 12px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644402531421"] {
      color: #000000;
      z-index: 42;
      top: 379px;
      left: calc(50% - 600px + 136px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644402531421"] .tn-atom {
      color: #000000;
      font-size: 18px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.45;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531421"] {
        top: 389px;
        left: calc(50% - 480px + 108px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531421"] .tn-atom {
        font-size: 18px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531421"] {
        top: 354px;
        left: calc(50% - 320px + 51px);
        width: 226px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531421"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531421"] {
        top: 354px;
        left: calc(50% - 240px + 90px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531421"] .tn-atom {
        font-size: 18px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531421"] {
        top: 342px;
        left: calc(50% - 160px + 68px);
        width: 200px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531421"] {
        text-align: left;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531421"] .tn-atom {
        font-size: 14px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644402531425"] {
      color: #000000;
      z-index: 39;
      top: 345px;
      left: calc(50% - 600px + 136px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644402531425"] .tn-atom {
      color: #000000;
      font-size: 24px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.4;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531425"] {
        top: 355px;
        left: calc(50% - 480px + 108px);
        width: 310px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531425"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531425"] {
        top: 320px;
        left: calc(50% - 320px + 51px);
        width: 226px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531425"] {
        top: 322px;
        left: calc(50% - 240px + 90px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531425"] .tn-atom {
        font-size: 22px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644402531425"] {
        top: 310px;
        left: calc(50% - 160px + 68px);
        width: 200px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644402531425"] {
        text-align: left;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1638545633355"] {
      z-index: 46;
      top: 352px;
      left: calc(50% - 600px + 80px);
      width: 40px;
    }

    #rec411266622 .tn-elem[data-elem-id="1638545633355"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1638545633355"] {
        top: 366px;
        left: calc(50% - 480px + 60px);
        width: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1638545633355"] {
        top: 330px;
        left: calc(50% - 320px + 11px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1638545633355"] {
        top: 332px;
        left: calc(50% - 240px + 32px);
        width: 40px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1638545633355"] {
        top: 310px;
        left: calc(50% - 160px + 12px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644404720466"] {
      color: #000000;
      z-index: 56;
      top: 51px;
      left: calc(50% - 600px + 721px);
      width: 157px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644404720466"] .tn-atom {
      color: #000000;
      font-size: 36px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720466"] {
        top: 72px;
        left: calc(50% - 480px + 550px);
        width: 136px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404720466"] .tn-atom {
        font-size: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720466"] {
        top: 50px;
        left: calc(50% - 320px + 371px);
        width: 234px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404720466"] .tn-atom {
        line-height: 1.2;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720466"] {
        top: 577px;
        left: calc(50% - 240px + 32px);
        width: 151px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404720466"] .tn-atom {
        font-size: 36px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720466"] {
        top: 562px;
        left: calc(50% - 160px + 10px);
        width: 70px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644404720472"] {
      color: #000000;
      z-index: 57;
      top: 51px;
      left: calc(50% - 600px + 960px);
      width: 157px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644404720472"] .tn-atom {
      color: #000000;
      font-size: 36px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720472"] {
        top: 72px;
        left: calc(50% - 480px + 750px);
        width: 161px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404720472"] .tn-atom {
        font-size: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720472"] {
        top: 88px;
        left: calc(50% - 320px + 371px);
        width: 234px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404720472"] .tn-atom {
        line-height: 1.2;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720472"] {
        top: 577px;
        left: calc(50% - 240px + 247px);
        width: 181px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404720472"] .tn-atom {
        font-size: 36px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720472"] {
        top: 603px;
        left: calc(50% - 160px + 10px);
        width: 70px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644404720478"] {
      z-index: 58;
      top: 43px;
      left: calc(50% - 600px + 878px);
      width: 70px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644404720478"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720478"] {
        top: 73px;
        left: calc(50% - 480px + 694px);
        width: 48px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720478"] {
        top: 43px;
        left: calc(50% - 320px + 523px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720478"] {
        top: 577px;
        left: calc(50% - 240px + 191px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644404720478"] {
        top: 560px;
        left: calc(50% - 160px + 170px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644404763947"] {
      z-index: 61;
      top: 37px;
      left: calc(50% - 600px + 116px);
      width: 29px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644404763947"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763947"] {
        top: 55px;
        left: calc(50% - 480px + 96px);
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763947"] {
        top: 42px;
        left: calc(50% - 320px + 46px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763947"] {
        top: 42px;
        left: calc(50% - 240px + 65px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763947"] {
        top: 26px;
        left: calc(50% - 160px + 46px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644404763940"] {
      z-index: 60;
      top: 47px;
      left: calc(50% - 600px + 80px);
      width: 55px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644404763940"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763940"] {
        top: 65px;
        left: calc(50% - 480px + 60px);
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763940"] {
        top: 52px;
        left: calc(50% - 320px + 10px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763940"] {
        top: 52px;
        left: calc(50% - 240px + 29px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763940"] {
        top: 36px;
        left: calc(50% - 160px + 10px);
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644404763934"] {
      color: #000000;
      z-index: 59;
      top: 51px;
      left: calc(50% - 600px + 158px);
      width: 425px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644404763934"] .tn-atom {
      color: #000000;
      font-size: 36px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.55;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763934"] {
        top: 72px;
        left: calc(50% - 480px + 133px);
        width: 266px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404763934"] .tn-atom {
        font-size: 32px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763934"] {
        top: 65px;
        left: calc(50% - 320px + 91px);
        width: 219px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404763934"] .tn-atom {
        line-height: 1.2;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763934"] {
        top: 58px;
        left: calc(50% - 240px + 109px);
        width: 360px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644404763934"] .tn-atom {
        font-size: 36px;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644404763934"] {
        top: 16px;
        left: calc(50% - 160px + 90px);
        width: 219px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644403710314"] {
      color: #000000;
      z-index: 16;
      top: 378px;
      left: calc(50% - 600px + 757px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644403710314"] .tn-atom {
      color: #000000;
      font-size: 18px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.45;
      font-weight: 400;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710314"] {
        top: 390px;
        left: calc(50% - 480px + 589px);
        width: 299px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710314"] .tn-atom {
        font-size: 18px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710314"] {
        top: 354px;
        left: calc(50% - 320px + 393px);
        width: 235px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710314"] .tn-atom {
        font-size: 14px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710314"] {
        top: 873px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710314"] .tn-atom {
        font-size: 18px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710314"] {
        top: 886px;
        left: calc(50% - 160px + 49px);
        width: 260px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710314"] {
        text-align: left;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710314"] .tn-atom {
        font-size: 14px;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644403710319"] {
      color: #000000;
      z-index: 15;
      top: 345px;
      left: calc(50% - 600px + 757px);
      width: 360px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644403710319"] .tn-atom {
      color: #000000;
      font-size: 24px;
      font-family: 'IBM Plex Sans', Arial, sans-serif;
      line-height: 1.4;
      font-weight: 700;
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710319"] {
        top: 355px;
        left: calc(50% - 480px + 589px);
        width: 299px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710319"] .tn-atom {
        font-size: 24px;
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710319"] {
        top: 320px;
        left: calc(50% - 320px + 393px);
        width: 235px;
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710319"] {
        top: 841px;
        left: calc(50% - 240px + 88px);
        width: 380px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710319"] .tn-atom {
        font-size: 22px;
        line-height: 1.45;
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710319"] {
        top: 854px;
        left: calc(50% - 160px + 49px);
        width: 260px;
      }

      #rec411266622 .tn-elem[data-elem-id="1644403710319"] {
        text-align: left;
      }
    }

    #rec411266622 .tn-elem[data-elem-id="1644403710323"] {
      z-index: 17;
      top: 352px;
      left: calc(50% - 600px + 718px);
      width: 23px;
    }

    #rec411266622 .tn-elem[data-elem-id="1644403710323"] .tn-atom {
      background-position: center center;
      border-color: transparent;
      border-style: solid;
    }

    @media screen and (max-width: 1199px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710323"] {
        top: 360px;
        left: calc(50% - 480px + 550px);
      }
    }

    @media screen and (max-width: 959px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710323"] {
        top: 326px;
        left: calc(50% - 320px + 362px);
      }
    }

    @media screen and (max-width: 639px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710323"] {
        top: 846px;
        left: calc(50% - 240px + 49px);
      }
    }

    @media screen and (max-width: 479px) {
      #rec411266622 .tn-elem[data-elem-id="1644403710323"] {
        top: 859px;
        left: calc(50% - 160px + 10px);
      }
    }</style>
    <div class="t396">
      <div class="t396__artboard rendered" data-artboard-recid="411266622" data-artboard-height="580"
           data-artboard-height-res-960="580" data-artboard-height-res-640="522" data-artboard-height-res-480="1040"
           data-artboard-height-res-320="1040" data-artboard-height_vh="" data-artboard-valign="center"
           data-artboard-upscale="grid" data-artboard-ovrflw="" data-artboard-proxy-min-offset-top="0"
           data-artboard-proxy-min-height="580" data-artboard-proxy-max-height="580">
        <div class="t396__carrier" data-artboard-recid="411266622"></div>
        <div class="t396__filter" data-artboard-recid="411266622"></div>
        <div class="t396__elem tn-elem tn-elem__4112666221470210011265" data-elem-id="1470210011265"
             data-elem-type="text" data-field-top-value="179" data-field-top-res-960-value="179"
             data-field-top-res-640-value="180" data-field-top-res-480-value="179" data-field-top-res-320-value="179"
             data-field-left-value="220" data-field-left-res-960-value="170" data-field-left-res-640-value="20"
             data-field-left-res-480-value="11" data-field-left-res-320-value="11" data-field-width-value="760"
             data-field-width-res-960-value="620" data-field-width-res-640-value="600"
             data-field-width-res-480-value="460" data-field-width-res-320-value="300" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 179px; left: 332.5px; width: 760px;">
          <div class="tn-atom" field="tn_text_1470210011265"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221635534621515" data-elem-id="1635534621515"
             data-elem-type="shape" data-field-top-value="0" data-field-top-res-960-value="0"
             data-field-top-res-640-value="0" data-field-top-res-480-value="0" data-field-top-res-320-value="0"
             data-field-left-value="0" data-field-left-res-960-value="0" data-field-left-res-640-value="0"
             data-field-left-res-480-value="0" data-field-left-res-320-value="0" data-field-height-value="580"
             data-field-height-res-640-value="522" data-field-height-res-480-value="50"
             data-field-height-res-320-value="50" data-field-width-value="50" data-field-width-res-960-value="50"
             data-field-width-res-640-value="50" data-field-width-res-480-value="100"
             data-field-width-res-320-value="100" data-field-axisy-value="top" data-field-axisx-value="left"
             data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
             data-field-heightunits-value="px" data-field-heightunits-res-480-value="%" data-field-widthunits-value="%"
             data-field-widthunits-res-960-value="%"
             data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
             style="width: 600px; left: 112.5px; top: 0px; height: 580px;">
          <div class="tn-atom"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546079516" data-elem-id="1638546079516"
             data-elem-type="shape" data-field-top-value="455" data-field-top-res-960-value="448"
             data-field-top-res-640-value="406" data-field-top-res-480-value="412" data-field-top-res-320-value="397"
             data-field-left-value="79" data-field-left-res-960-value="60" data-field-left-res-640-value="0"
             data-field-left-res-480-value="10" data-field-left-res-320-value="10" data-field-height-value="2"
             data-field-width-value="400" data-field-width-res-960-value="350" data-field-width-res-640-value="50"
             data-field-width-res-480-value="460" data-field-width-res-320-value="300" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="px" data-field-widthunits-value="px"
             data-field-widthunits-res-640-value="%" data-field-widthunits-res-480-value="px"
             data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
             style="width: 400px; left: 191.5px; top: 455px; height: 2px;">
          <div class="tn-atom"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546327613" data-elem-id="1638546327613"
             data-elem-type="shape" data-field-top-value="455" data-field-top-res-960-value="448"
             data-field-top-res-640-value="406" data-field-top-res-480-value="930" data-field-top-res-320-value="938"
             data-field-left-value="721" data-field-left-res-960-value="550" data-field-left-res-640-value="320"
             data-field-left-res-480-value="10" data-field-left-res-320-value="10" data-field-height-value="2"
             data-field-width-value="400" data-field-width-res-960-value="350" data-field-width-res-640-value="50"
             data-field-width-res-480-value="460" data-field-width-res-320-value="300" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="px" data-field-widthunits-value="px"
             data-field-widthunits-res-640-value="%" data-field-widthunits-res-480-value="px"
             data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
             style="width: 400px; left: 833.5px; top: 455px; height: 2px;">
          <div class="tn-atom"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221635617609860" data-elem-id="1635617609860"
             data-elem-type="shape" data-field-top-value="0" data-field-top-res-960-value="0"
             data-field-top-res-640-value="0" data-field-top-res-480-value="533" data-field-top-res-320-value="520"
             data-field-left-value="600" data-field-left-res-960-value="480" data-field-left-res-640-value="320"
             data-field-left-res-480-value="0" data-field-left-res-320-value="0" data-field-height-value="580"
             data-field-height-res-640-value="522" data-field-height-res-480-value="50"
             data-field-height-res-320-value="50" data-field-width-value="50" data-field-width-res-960-value="50"
             data-field-width-res-640-value="50" data-field-width-res-480-value="100"
             data-field-width-res-320-value="100" data-field-axisy-value="top" data-field-axisx-value="left"
             data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
             data-field-heightunits-value="px" data-field-heightunits-res-480-value="%" data-field-widthunits-value="%"
             data-field-widthunits-res-960-value="%"
             data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
             style="width: 600px; left: 712.5px; top: 0px; height: 580px;">
          <div class="tn-atom"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546182270" data-elem-id="1638546182270"
             data-elem-type="text" data-field-top-value="493" data-field-top-res-960-value="486"
             data-field-top-res-640-value="436" data-field-top-res-480-value="448" data-field-top-res-320-value="425"
             data-field-left-value="192" data-field-left-res-960-value="151" data-field-left-res-640-value="96"
             data-field-left-res-480-value="136" data-field-left-res-320-value="114" data-field-width-value="187"
             data-field-width-res-960-value="185" data-field-width-res-640-value="209"
             data-field-width-res-480-value="191" data-field-width-res-320-value="147" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 493px; left: 304.5px; width: 187px;">
          <div class="tn-atom" field="tn_text_1638546182270">/ month<br>for 50 users</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546133307" data-elem-id="1638546133307"
             data-elem-type="text" data-field-top-value="483" data-field-top-res-960-value="482"
             data-field-top-res-640-value="432" data-field-top-res-480-value="438" data-field-top-res-320-value="415"
             data-field-left-value="80" data-field-left-res-960-value="60" data-field-left-res-640-value="11"
             data-field-left-res-480-value="32" data-field-left-res-320-value="10" data-field-width-value="87"
             data-field-width-res-960-value="276" data-field-width-res-640-value="69"
             data-field-width-res-480-value="62" data-field-width-res-320-value="96" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 483px; left: 192.5px; width: 87px;">
          <div class="tn-atom" field="tn_text_1638546133307">$491</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546327618" data-elem-id="1638546327618"
             data-elem-type="text" data-field-top-value="493" data-field-top-res-960-value="486"
             data-field-top-res-640-value="436" data-field-top-res-480-value="966" data-field-top-res-320-value="966"
             data-field-left-value="811" data-field-left-res-960-value="622" data-field-left-res-640-value="431"
             data-field-left-res-480-value="112" data-field-left-res-320-value="90" data-field-width-value="268"
             data-field-width-res-960-value="212" data-field-width-res-640-value="209"
             data-field-width-res-480-value="191" data-field-width-res-320-value="190" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 493px; left: 923.5px; width: 268px;">
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546327621" data-elem-id="1638546327621"
             data-elem-type="text" data-field-top-value="483" data-field-top-res-960-value="482"
             data-field-top-res-640-value="432" data-field-top-res-480-value="956" data-field-top-res-320-value="956"
             data-field-left-value="722" data-field-left-res-960-value="550" data-field-left-res-640-value="362"
             data-field-left-res-480-value="32" data-field-left-res-320-value="10" data-field-width-value="73"
             data-field-width-res-960-value="72" data-field-width-res-640-value="69" data-field-width-res-480-value="52"
             data-field-width-res-320-value="72" data-field-axisy-value="top" data-field-axisx-value="left"
             data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
             data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 483px; left: 834.5px; width: 73px;">
          <div class="tn-atom" field="tn_text_1638546327621">FREE</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546554805" data-elem-id="1638546554805"
             data-elem-type="shape" data-field-top-value="226" data-field-top-res-960-value="246"
             data-field-top-res-640-value="250" data-field-top-res-480-value="509" data-field-top-res-320-value="496"
             data-field-left-value="560" data-field-left-res-960-value="448" data-field-left-res-640-value="296"
             data-field-left-res-480-value="216" data-field-left-res-320-value="136" data-field-height-value="80"
             data-field-height-res-960-value="64" data-field-height-res-640-value="48" data-field-width-value="80"
             data-field-width-res-960-value="64" data-field-width-res-640-value="48" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="px" data-field-widthunits-value="px"
             data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
             style="width: 80px; left: 672.5px; top: 226px; height: 80px;">
          <div class="tn-atom"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638546609403" data-elem-id="1638546609403"
             data-elem-type="text" data-field-top-value="236" data-field-top-res-960-value="260"
             data-field-top-res-640-value="255" data-field-top-res-480-value="510" data-field-top-res-320-value="497"
             data-field-left-value="560" data-field-left-res-960-value="448" data-field-left-res-640-value="300"
             data-field-left-res-480-value="220" data-field-left-res-320-value="125" data-field-width-value="80"
             data-field-width-res-960-value="64" data-field-width-res-640-value="40" data-field-width-res-480-value="40"
             data-field-width-res-320-value="70" data-field-axisy-value="top" data-field-axisx-value="left"
             data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
             data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 236px; left: 672.5px; width: 80px;">
          <div class="tn-atom" field="tn_text_1638546609403">vs</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644400100958" data-elem-id="1644400100958"
             data-elem-type="text" data-field-top-value="279" data-field-top-res-960-value="297"
             data-field-top-res-640-value="268" data-field-top-res-480-value="779" data-field-top-res-320-value="802"
             data-field-left-value="760" data-field-left-res-960-value="589" data-field-left-res-640-value="393"
             data-field-left-res-480-value="88" data-field-left-res-320-value="49" data-field-width-value="360"
             data-field-width-res-960-value="299" data-field-width-res-640-value="235"
             data-field-width-res-480-value="380" data-field-width-res-320-value="260" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 279px; left: 872.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644400100958">Lighting-fast Kanban board</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644400100961" data-elem-id="1644400100961"
             data-elem-type="text" data-field-top-value="246" data-field-top-res-960-value="262"
             data-field-top-res-640-value="234" data-field-top-res-480-value="747" data-field-top-res-320-value="770"
             data-field-left-value="760" data-field-left-res-960-value="589" data-field-left-res-640-value="393"
             data-field-left-res-480-value="88" data-field-left-res-320-value="49" data-field-width-value="360"
             data-field-width-res-960-value="299" data-field-width-res-640-value="235"
             data-field-width-res-480-value="380" data-field-width-res-320-value="260" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 246px; left: 872.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644400100961">Chpokify/ Kanban</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644400100964" data-elem-id="1644400100964"
             data-elem-type="image" data-field-top-value="253" data-field-top-res-960-value="267"
             data-field-top-res-640-value="240" data-field-top-res-480-value="752" data-field-top-res-320-value="775"
             data-field-left-value="721" data-field-left-res-960-value="550" data-field-left-res-640-value="362"
             data-field-left-res-480-value="49" data-field-left-res-320-value="10" data-field-width-value="23"
             data-field-axisy-value="top" data-field-axisx-value="left" data-field-container-value="grid"
             data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
             data-field-widthunits-value="px" data-field-filewidth-value="160" data-field-fileheight-value="160"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 833.5px; top: 253px; width: 23px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild6262-6336-4533-b830-623839323266__check-mark-button_27.png"
                                    src="/langings/agileEcosystem/images/tild6262-6336-4533-b830-623839323266__check-mark-button_27.png"
                                    imgfield="tn_img_1644400100964"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644400207455" data-elem-id="1644400207455"
             data-elem-type="text" data-field-top-value="180" data-field-top-res-960-value="204"
             data-field-top-res-640-value="182" data-field-top-res-480-value="689" data-field-top-res-320-value="718"
             data-field-left-value="760" data-field-left-res-960-value="589" data-field-left-res-640-value="393"
             data-field-left-res-480-value="88" data-field-left-res-320-value="49" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="235"
             data-field-width-res-480-value="360" data-field-width-res-320-value="260" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 180px; left: 872.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644400207455">Easy-as-pie planing poker</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644400207459" data-elem-id="1644400207459"
             data-elem-type="text" data-field-top-value="147" data-field-top-res-960-value="169"
             data-field-top-res-640-value="148" data-field-top-res-480-value="657" data-field-top-res-320-value="686"
             data-field-left-value="760" data-field-left-res-960-value="589" data-field-left-res-640-value="393"
             data-field-left-res-480-value="88" data-field-left-res-320-value="49" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="235"
             data-field-width-res-480-value="360" data-field-width-res-320-value="260" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 147px; left: 872.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644400207459">Chpokify/ Poker</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644400207462" data-elem-id="1644400207462"
             data-elem-type="image" data-field-top-value="154" data-field-top-res-960-value="174"
             data-field-top-res-640-value="154" data-field-top-res-480-value="662" data-field-top-res-320-value="691"
             data-field-left-value="721" data-field-left-res-960-value="550" data-field-left-res-640-value="362"
             data-field-left-res-480-value="49" data-field-left-res-320-value="10" data-field-width-value="23"
             data-field-axisy-value="top" data-field-axisx-value="left" data-field-container-value="grid"
             data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
             data-field-widthunits-value="px" data-field-filewidth-value="160" data-field-fileheight-value="160"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 833.5px; top: 154px; width: 23px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild6262-6336-4533-b830-623839323266__check-mark-button_27.png"
                                    imgfield="tn_img_1644400207462"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644402283973" data-elem-id="1644402283973"
             data-elem-type="text" data-field-top-value="181" data-field-top-res-960-value="203"
             data-field-top-res-640-value="268" data-field-top-res-480-value="171" data-field-top-res-320-value="174"
             data-field-left-value="137" data-field-left-res-960-value="108" data-field-left-res-640-value="51"
             data-field-left-res-480-value="88" data-field-left-res-320-value="68" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="226"
             data-field-width-res-480-value="380" data-field-width-res-320-value="200" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 181px; left: 249.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644402283973">$375 / month</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644402283976" data-elem-id="1644402283976"
             data-elem-type="text" data-field-top-value="147" data-field-top-res-960-value="169"
             data-field-top-res-640-value="234" data-field-top-res-480-value="139" data-field-top-res-320-value="142"
             data-field-left-value="137" data-field-left-res-960-value="108" data-field-left-res-640-value="51"
             data-field-left-res-480-value="88" data-field-left-res-320-value="68" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="226"
             data-field-width-res-480-value="380" data-field-width-res-320-value="200" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 147px; left: 249.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644402283976">Atlassian Jira</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638544950148" data-elem-id="1638544950148"
             data-elem-type="image" data-field-top-value="147" data-field-top-res-960-value="180"
             data-field-top-res-640-value="237" data-field-top-res-480-value="144" data-field-top-res-320-value="142"
             data-field-left-value="81" data-field-left-res-960-value="60" data-field-left-res-640-value="11"
             data-field-left-res-480-value="32" data-field-left-res-320-value="12" data-field-width-value="40"
             data-field-width-res-960-value="32" data-field-width-res-480-value="40" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-field-filewidth-value="141" data-field-fileheight-value="144"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 193.5px; top: 147px; width: 40px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild3362-3335-4461-b039-656464633564__jira.png"
                                    src="/langings/agileEcosystem/images/tild3362-3335-4461-b039-656464633564__jira.png"
                                    imgfield="tn_img_1638544950148"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644402526773" data-elem-id="1644402526773"
             data-elem-type="text" data-field-top-value="276" data-field-top-res-960-value="296"
             data-field-top-res-640-value="182" data-field-top-res-480-value="261" data-field-top-res-320-value="258"
             data-field-left-value="137" data-field-left-res-960-value="108" data-field-left-res-640-value="51"
             data-field-left-res-480-value="88" data-field-left-res-320-value="68" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="226"
             data-field-width-res-480-value="380" data-field-width-res-320-value="200" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 276px; left: 249.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644402526773">$87 / month</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644402526777" data-elem-id="1644402526777"
             data-elem-type="text" data-field-top-value="242" data-field-top-res-960-value="262"
             data-field-top-res-640-value="148" data-field-top-res-480-value="229" data-field-top-res-320-value="226"
             data-field-left-value="137" data-field-left-res-960-value="108" data-field-left-res-640-value="51"
             data-field-left-res-480-value="88" data-field-left-res-320-value="68" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="226"
             data-field-width-res-480-value="380" data-field-width-res-320-value="200" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 242px; left: 249.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644402526777">Jira Planing Poker</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638545244697" data-elem-id="1638545244697"
             data-elem-type="image" data-field-top-value="242" data-field-top-res-960-value="273"
             data-field-top-res-640-value="158" data-field-top-res-480-value="239" data-field-top-res-320-value="226"
             data-field-left-value="81" data-field-left-res-960-value="60" data-field-left-res-640-value="11"
             data-field-left-res-480-value="32" data-field-left-res-320-value="12" data-field-width-value="40"
             data-field-width-res-960-value="32" data-field-width-res-480-value="40" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-field-filewidth-value="144" data-field-fileheight-value="144"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 193.5px; top: 242px; width: 40px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild3162-3963-4835-b334-613330663334__poker_1.png"
                                    src="/langings/agileEcosystem/images/tild3162-3963-4835-b334-613330663334__poker_1.png"
                                    imgfield="tn_img_1638545244697"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644402531421" data-elem-id="1644402531421"
             data-elem-type="text" data-field-top-value="379" data-field-top-res-960-value="389"
             data-field-top-res-640-value="354" data-field-top-res-480-value="354" data-field-top-res-320-value="342"
             data-field-left-value="136" data-field-left-res-960-value="108" data-field-left-res-640-value="51"
             data-field-left-res-480-value="90" data-field-left-res-320-value="68" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="226"
             data-field-width-res-480-value="380" data-field-width-res-320-value="200" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 379px; left: 248.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644402531421">$29 / month</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644402531425" data-elem-id="1644402531425"
             data-elem-type="text" data-field-top-value="345" data-field-top-res-960-value="355"
             data-field-top-res-640-value="320" data-field-top-res-480-value="322" data-field-top-res-320-value="310"
             data-field-left-value="136" data-field-left-res-960-value="108" data-field-left-res-640-value="51"
             data-field-left-res-480-value="90" data-field-left-res-320-value="68" data-field-width-value="360"
             data-field-width-res-960-value="310" data-field-width-res-640-value="226"
             data-field-width-res-480-value="380" data-field-width-res-320-value="200" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 345px; left: 248.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644402531425">Easy Retro</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221638545633355" data-elem-id="1638545633355"
             data-elem-type="image" data-field-top-value="352" data-field-top-res-960-value="366"
             data-field-top-res-640-value="330" data-field-top-res-480-value="332" data-field-top-res-320-value="310"
             data-field-left-value="80" data-field-left-res-960-value="60" data-field-left-res-640-value="11"
             data-field-left-res-480-value="32" data-field-left-res-320-value="12" data-field-width-value="40"
             data-field-width-res-960-value="32" data-field-width-res-480-value="40" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-field-filewidth-value="144" data-field-fileheight-value="144"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 192.5px; top: 352px; width: 40px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild3338-3838-4264-b165-373435393265__retro.png"
                                    src="/langings/agileEcosystem/images/tild3338-3838-4264-b165-373435393265__retro.png"
                                    imgfield="tn_img_1638545633355"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644404720466" data-elem-id="1644404720466"
             data-elem-type="text" data-field-top-value="51" data-field-top-res-960-value="72"
             data-field-top-res-640-value="50" data-field-top-res-480-value="577" data-field-top-res-320-value="562"
             data-field-left-value="721" data-field-left-res-960-value="550" data-field-left-res-640-value="371"
             data-field-left-res-480-value="32" data-field-left-res-320-value="10" data-field-width-value="157"
             data-field-width-res-960-value="136" data-field-width-res-640-value="234"
             data-field-width-res-480-value="151" data-field-width-res-320-value="70" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 51px; left: 833.5px; width: 157px;">
          <div class="tn-atom" field="tn_text_1644404720466">Chpokify</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644404720472" data-elem-id="1644404720472"
             data-elem-type="text" data-field-top-value="51" data-field-top-res-960-value="72"
             data-field-top-res-640-value="88" data-field-top-res-480-value="577" data-field-top-res-320-value="603"
             data-field-left-value="960" data-field-left-res-960-value="750" data-field-left-res-640-value="371"
             data-field-left-res-480-value="247" data-field-left-res-320-value="10" data-field-width-value="157"
             data-field-width-res-960-value="161" data-field-width-res-640-value="234"
             data-field-width-res-480-value="181" data-field-width-res-320-value="70" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 51px; left: 1072.5px; width: 157px;">
          <div class="tn-atom" field="tn_text_1644404720472">Ecosystem</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644404720478" data-elem-id="1644404720478"
             data-elem-type="image" data-field-top-value="43" data-field-top-res-960-value="73"
             data-field-top-res-640-value="43" data-field-top-res-480-value="577" data-field-top-res-320-value="560"
             data-field-left-value="878" data-field-left-res-960-value="694" data-field-left-res-640-value="523"
             data-field-left-res-480-value="191" data-field-left-res-320-value="170" data-field-width-value="70"
             data-field-width-res-960-value="48" data-field-axisy-value="top" data-field-axisx-value="left"
             data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
             data-field-heightunits-value="" data-field-widthunits-value="px" data-field-filewidth-value="160"
             data-field-fileheight-value="160"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 990.5px; top: 43px; width: 70px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild3366-3639-4135-b134-646164313365__star-struck_1f929.png"
                                    src="/langings/agileEcosystem/images/tild3366-3639-4135-b134-646164313365__star-struck_1f929.png"
                                    imgfield="tn_img_1644404720478"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644404763947" data-elem-id="1644404763947"
             data-elem-type="image" data-field-top-value="37" data-field-top-res-960-value="55"
             data-field-top-res-640-value="42" data-field-top-res-480-value="42" data-field-top-res-320-value="26"
             data-field-left-value="116" data-field-left-res-960-value="96" data-field-left-res-640-value="46"
             data-field-left-res-480-value="65" data-field-left-res-320-value="46" data-field-width-value="29"
             data-field-axisy-value="top" data-field-axisx-value="left" data-field-container-value="grid"
             data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
             data-field-widthunits-value="px" data-field-filewidth-value="160" data-field-fileheight-value="160"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 228.5px; top: 37px; width: 29px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild3761-3434-4666-b532-663462383634__exploding-head_1f92f.png"
                                    src="/langings/agileEcosystem/images/tild3761-3434-4666-b532-663462383634__exploding-head_1f92f.png"
                                    imgfield="tn_img_1644404763947"></div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644404763940" data-elem-id="1644404763940"
             data-elem-type="image" data-field-top-value="47" data-field-top-res-960-value="65"
             data-field-top-res-640-value="52" data-field-top-res-480-value="52" data-field-top-res-320-value="36"
             data-field-left-value="80" data-field-left-res-960-value="60" data-field-left-res-640-value="10"
             data-field-left-res-480-value="29" data-field-left-res-320-value="10" data-field-width-value="55"
             data-field-axisy-value="top" data-field-axisx-value="left" data-field-container-value="grid"
             data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
             data-field-widthunits-value="px" data-field-filewidth-value="160" data-field-fileheight-value="160"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 192.5px; top: 47px; width: 55px;">
          <div class="tn-atom">
            <img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild6130-6165-4662-b534-333430623537__woman-facepalming-li.png"
                                    src="/langings/agileEcosystem/images/tild6130-6165-4662-b534-333430623537__woman-facepalming-li.png"
                                    imgfield="tn_img_1644404763940"/>
          </div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644404763934" data-elem-id="1644404763934"
             data-elem-type="text" data-field-top-value="51" data-field-top-res-960-value="72"
             data-field-top-res-640-value="65" data-field-top-res-480-value="58" data-field-top-res-320-value="16"
             data-field-left-value="158" data-field-left-res-960-value="133" data-field-left-res-640-value="91"
             data-field-left-res-480-value="109" data-field-left-res-320-value="90" data-field-width-value="425"
             data-field-width-res-960-value="266" data-field-width-res-640-value="219"
             data-field-width-res-480-value="360" data-field-width-res-320-value="219" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 51px; left: 270.5px; width: 425px;">
          <div class="tn-atom" field="tn_text_1644404763934">Do it yourself</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644403710314" data-elem-id="1644403710314"
             data-elem-type="text" data-field-top-value="378" data-field-top-res-960-value="390"
             data-field-top-res-640-value="354" data-field-top-res-480-value="873" data-field-top-res-320-value="886"
             data-field-left-value="757" data-field-left-res-960-value="589" data-field-left-res-640-value="393"
             data-field-left-res-480-value="88" data-field-left-res-320-value="49" data-field-width-value="360"
             data-field-width-res-960-value="299" data-field-width-res-640-value="235"
             data-field-width-res-480-value="380" data-field-width-res-320-value="260" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 378px; left: 869.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644403710314">Stress-free retrospective tool</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644403710319" data-elem-id="1644403710319"
             data-elem-type="text" data-field-top-value="345" data-field-top-res-960-value="355"
             data-field-top-res-640-value="320" data-field-top-res-480-value="841" data-field-top-res-320-value="854"
             data-field-left-value="757" data-field-left-res-960-value="589" data-field-left-res-640-value="393"
             data-field-left-res-480-value="88" data-field-left-res-320-value="49" data-field-width-value="360"
             data-field-width-res-960-value="299" data-field-width-res-640-value="235"
             data-field-width-res-480-value="380" data-field-width-res-320-value="260" data-field-axisy-value="top"
             data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="px"
             data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
             data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
             style="top: 345px; left: 869.5px; width: 360px;">
          <div class="tn-atom" field="tn_text_1644403710319">Chpokify/ Retro</div>
        </div>
        <div class="t396__elem tn-elem tn-elem__4112666221644403710323" data-elem-id="1644403710323"
             data-elem-type="image" data-field-top-value="352" data-field-top-res-960-value="360"
             data-field-top-res-640-value="326" data-field-top-res-480-value="846" data-field-top-res-320-value="859"
             data-field-left-value="718" data-field-left-res-960-value="550" data-field-left-res-640-value="362"
             data-field-left-res-480-value="49" data-field-left-res-320-value="10" data-field-width-value="23"
             data-field-axisy-value="top" data-field-axisx-value="left" data-field-container-value="grid"
             data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
             data-field-widthunits-value="px" data-field-filewidth-value="160" data-field-fileheight-value="160"
             data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
             style="left: 830.5px; top: 352px; width: 23px;">
          <div class="tn-atom"><img class="tn-atom__img t-img"
                                    data-original="/langings/agileEcosystem/images/tild6262-6336-4533-b830-623839323266__check-mark-button_27.png"
                                    src="/langings/agileEcosystem/images/tild6262-6336-4533-b830-623839323266__check-mark-button_27.png"
                                    imgfield="tn_img_1644403710323"></div>
        </div>
      </div>
    </div>
    <script type="text/javascript">$(document)
      .ready(function () {
        t396_init('411266622');
      });</script>
  </div>
  <div id="rec380620775" class="r t-rec t-rec_pt_90 t-rec_pb_150"
       style="padding-top:90px;padding-bottom:150px;background-color:#f6f6f6; " data-record-type="509"
       data-bg-color="#f6f6f6" data-animationappear="off">
    <div class="t509">
      <div class="t-section__container t-container">
        <div class="t-col t-col_12">
          <div class="t-section__topwrapper t-align_center">
            <div class="t-section__title t-title t-title_xs" field="btitle">Why you'll love us</div>
            <div class="t-section__descr t-descr t-descr_xl t-margin_auto" field="bdescr">We work in the Agile team
              every day <br>and know what helps us to deliver products
            </div>
          </div>
        </div>
      </div>
      <div class="t-container">
        <div class="t509__colwrapper t-col t-col_10 t-prefix_1">
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1476897493817"
                 data-original="/langings/agileEcosystem/images/tild6634-3364-4639-b236-373038623130__frame_583.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild6634-3364-4639-b236-373038623130__frame_583.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1476897493817" style="">Easy sprint
                    planning board
                  </div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1476897493817" style="">Chpokify is the
                    best way to plan your work without getting overwhelmed or bored while setting up your teams. You can
                    create, move, drag-and-drop cards representing tasks in a project right on top of each other!
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild6634-3364-4639-b236-373038623130__frame_583.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1476897493817"
                   data-original="/langings/agileEcosystem/images/tild6634-3364-4639-b236-373038623130__frame_583.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild6634-3364-4639-b236-373038623130__frame_583.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
          <div class="t509__separator t-clear" style=""></div>
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1476897695209"
                 data-original="/langings/agileEcosystem/images/tild3238-6364-4762-b764-396666383038__poker.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild3238-6364-4762-b764-396666383038__poker.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild3238-6364-4762-b764-396666383038__poker.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1476897695209"
                   data-original="/langings/agileEcosystem/images/tild3238-6364-4762-b764-396666383038__poker.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild3238-6364-4762-b764-396666383038__poker.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1476897695209" style="">Precise
                    estimations scrum poker <br></div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1476897695209" style="">Get your
                    estimation into that sweet spot where you're just guessing what the effort will be without having to
                    overcommit and find yourself living up to those expectations as your project evolves.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__separator t-clear" style=""></div>
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1639476288432"
                 data-original="/langings/agileEcosystem/images/tild3965-6364-4330-a132-333032396464__teams.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild3965-6364-4330-a132-333032396464__teams.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1639476288432" style="">Estimate
                    multiple teams
                  </div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1639476288432" style="">With our
                    intuitive interface, you can quickly and easily create accurate and reliable estimates for every
                    team you manage. Get stats for each team separately and run sessions for multiple teams at once.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild3965-6364-4330-a132-333032396464__teams.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1639476288432"
                   data-original="/langings/agileEcosystem/images/tild3965-6364-4330-a132-333032396464__teams.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild3965-6364-4330-a132-333032396464__teams.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
          <div class="t509__separator t-clear" style=""></div>
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1637163696314"
                 data-original="/langings/agileEcosystem/images/tild3338-6334-4766-b162-633630303436__sandbox.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild3338-6334-4766-b162-633630303436__sandbox.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild3338-6334-4766-b162-633630303436__sandbox.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1637163696314"
                   data-original="/langings/agileEcosystem/images/tild3338-6334-4766-b162-633630303436__sandbox.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild3338-6334-4766-b162-633630303436__sandbox.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1637163696314" style="">Incognito
                    mode for retro
                  </div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1637163696314" style="">Fear of getting
                    the bad news first may lead to bottlenecks or decisions being delayed, hindering progress during
                    these crucial times. Chpokify is your best defense from those nagging “bad guy" Scrum team members
                    who always cause trouble.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__separator t-clear" style=""></div>
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1638890732005"
                 data-original="/langings/agileEcosystem/images/tild6666-3734-4437-a434-366662333136__videocall.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild6666-3734-4437-a434-366662333136__videocall.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1638890732005" style="">Videocall
                  </div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1638890732005" style="">Being able to
                    videocall your team is a huge plus for productivity. With Chpokify, you can easily keep in touch
                    with your colleagues without ever having to leave your desk.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild6666-3734-4437-a434-366662333136__videocall.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1638890732005"
                   data-original="/langings/agileEcosystem/images/tild6666-3734-4437-a434-366662333136__videocall.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild6666-3734-4437-a434-366662333136__videocall.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
          <div class="t509__separator t-clear" style=""></div>
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1638890789846"
                 data-original="/langings/agileEcosystem/images/tild3661-3461-4561-b330-303961386633__mode.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild3661-3461-4561-b330-303961386633__mode.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild3661-3461-4561-b330-303961386633__mode.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1638890789846"
                   data-original="/langings/agileEcosystem/images/tild3661-3461-4561-b330-303961386633__mode.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild3661-3461-4561-b330-303961386633__mode.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1638890789846" style="">Guided or
                    Free mode in Retro
                  </div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1638890789846" style="">Chpokify is the
                    best way to have productive Retro meetings. In Guided mode, you'll follow the steps and get through
                    your meeting quickly and easily. In Free mode, you can manually control the session flow and
                    customize it to fit your needs.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__separator t-clear" style=""></div>
          <div class="t509__col t-col t-col_5 t509__mobileimg">
            <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1638890832504"
                 data-original="/langings/agileEcosystem/images/tild3036-3139-4363-a462-383864326136__technique.svg"
                 style="background-image: url(/langings/agileEcosystem/images/tild3036-3139-4363-a462-383864326136__technique.svg); padding-bottom: 73.913%;"
                 data-image-width="460" data-image-height="340px"></div>
          </div>
          <div class="t509__col t-col t-col_5 t509__leftcol">
            <div class="t509__textwrapper t-align_left" style="max-width: 400px; height: 340px;">
              <div class="t509__content t-valign_middle">
                <div class="t509__box">
                  <div class="t509__title t-heading t-heading_xs " field="li_title__1638890832504" style="">Retro
                    Templates
                  </div>
                  <div class="t509__descr t-descr t-descr_sm " field="li_descr__1638890832504" style="">Make sure that
                    your Retro meetings are always well-organized and on track. With tons of pre-made templates to
                    choose from, you'll be able to find the perfect layout for your team needs every time.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t509__col t-col t-col_5 t509__rightcol t509__desktopimg">
            <div class="t509__imgwrapper" style="">
              <meta itemprop="image" content="/langings/agileEcosystem/images/tild3036-3139-4363-a462-383864326136__technique.svg">
              <div class="t509__blockimg t-bgimg" bgimgfield="li_img__1638890832504"
                   data-original="/langings/agileEcosystem/images/tild3036-3139-4363-a462-383864326136__technique.svg"
                   style="background-image: url(/langings/agileEcosystem/images/tild3036-3139-4363-a462-383864326136__technique.svg); padding-bottom: 73.913%;"
                   data-image-width="460" data-image-height="340px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <script type="text/javascript"> $(window)
      .resize(function () {
        t509_setHeight('380620775');
      });
    $(document)
      .ready(function () {
        t509_setHeight('380620775');
        $('.t509')
          .bind('displayChanged', function () {
            t509_setHeight('380620775');
          });
      });</script>
  </div>
  <div id="rec384568172" class="r t-rec t-rec_pt_90" style="padding-top:90px;background-color:#ffffff; "
       data-record-type="255" data-bg-color="#ffffff" data-animationappear="off">
    <div class="t225">
      <div class="t-container t-align_center">
        <div class="t-col t-col_10 t-prefix_1">
          <div class="t225__title t-title t-title_md" data-animate-style="fadeinup"
               data-animate-group="yes" field="title" style="transition-delay: 0s;">
            <div style="font-size: 46px;" data-customstyle="yes"><span
              style="font-size: 46px;">What our clients say</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec384566820" class="r t-rec t-rec_pb_90" style="padding-bottom:90px;background-color:#ffffff; "
       data-record-type="525" data-bg-color="#ffffff" data-animationappear="off">
    <div class="t525">
      <div class="t-section__container t-container">
        <div class="t-col t-col_12">
          <div class="t-section__topwrapper t-align_left">
            <div class="t-section__title t-title t-title_xs" data-animate-style="fadeinup"
                 data-animate-group="yes" field="btitle">
              <div style="color:#f0ad4e;" data-customstyle="yes"></div>
            </div>
            <div class="t-section__descr t-descr t-descr_xl" data-animate-style="fadeinup"
                 data-animate-group="yes" field="bdescr" style="transition-delay: 0.16s;">
              <div style="color:#f0ad4e;" data-customstyle="yes"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="t525__container t-container">
        <div class="t525__col t-col t-col_6"
             data-animate-style="fadeinup" data-animate-chain="yes">
          <div class="t-cell t-valign_top">
            <div class="t525__bgimg t525__img_circle t-bgimg"
                 data-original="/langings/agileEcosystem/images/tild6636-6431-4264-a637-396661323263__t03txsz1x-u01qyrbbfc.jpeg"
                 bgimgfield="li_img__1476964743259"
                 style=" background-image: url(/langings/agileEcosystem/images/tild6636-6431-4264-a637-396661323263__-__resizeb__20x__t03txsz1x-u01qyrbbfc.jpeg);"></div>
          </div>
          <div class="t525__textwrapper t525__textwr_leftpadding t-cell t-valign_top">
            <div class="t525__text t-text t-text_xs" field="li_text__1476964743259" style=" max-width: 400px;">Since we
              started using Chpokify we <strong>saved 14 minutes</strong> per estimation, mostly thanks to multiple
              teams in one session. I <strong>stopped wasting time</strong> manually copying-pasting issues from JIRA
              using <strong>integration</strong>. I also forgot about excel files thanks to <strong>automated
                summary</strong> that allows me to export and share results with team members.<br><br>It turned out that
              <strong>14 minutes per estimation</strong> saved us more than <strong>$10,000 per year</strong>.
            </div>
            <div class="t525__title t-name t-name_xs" field="li_title__1476964743259" style=" max-width: 400px;"><a
              href="https://www.linkedin.com/in/valeriya-stoyanova-104250137" target="_blank" style="" rel="noopener">Valy
              S.</a></div>
            <div class="t525__descr t-descr t-descr_xxs" field="li_descr__1476964743259" style=" max-width: 400px;">
              <span style="color: rgb(255, 191, 0);">★★★★★<br></span>Projects manager at Edu Platform
            </div>
          </div>
        </div>
        <div class="t525__col t-col t-col_6" data-animate-style="fadeinup"
             data-animate-chain="yes">
          <div class="t-cell t-valign_top">
            <div class="t525__bgimg t525__img_circle t-bgimg"
                 data-original="/langings/agileEcosystem/images/tild6631-6561-4337-b338-636436353737__t03txsz1x-u2k2894s2-.jpeg"
                 bgimgfield="li_img__1617480520625"
                 style=" background-image: url(/langings/agileEcosystem/images/tild6631-6561-4337-b338-636436353737__-__resizeb__20x__t03txsz1x-u2k2894s2-.jpeg);"></div>
          </div>
          <div class="t525__textwrapper t525__textwr_leftpadding t-cell t-valign_top">
            <div class="t525__text t-text t-text_xs" field="li_text__1617480520625" style=" max-width: 400px;">It has
              <strong>clear and simple interface </strong>and <strong> all the functionality</strong> you may need:
              paste story list easily, create different teams and assign members to them, create separate spaces for
              different projects in your company, view team stats during sessions, keep all your sessions' history in
              the same place, etc. It doesn't matter what devices we're using -- it works perfectly <strong>for both
                desktop and mobile.</strong> We <strong>don't spend our time on any technical imperfections</strong>
              anymore as we did with other tools. Instead we can focus on story details only and have <strong>really
                effective discussions</strong>.
            </div>
            <div class="t525__title t-name t-name_xs" field="li_title__1617480520625" style=" max-width: 400px;"><a
              href="https://www.linkedin.com/in/elena-chyrva-a7413452/" style="" target="_blank" rel="noopener">Alena
              C.</a></div>
            <div class="t525__descr t-descr t-descr_xxs" field="li_descr__1617480520625" style=" max-width: 400px;">
              <span style="color: rgb(255, 191, 0);">★★★★★<br></span>COO at Wisebits<br></div>
          </div>
        </div>
        <div class="t-clear t525__separator" style=""></div>
        <div class="t525__col t-col t-col_6" data-animate-style="fadeinup"
             data-animate-chain="yes">
          <div class="t-cell t-valign_top">
            <div class="t525__bgimg t525__img_circle t-bgimg"
                 data-original="/langings/agileEcosystem/images/tild3337-3732-4533-a232-363032663835__t03txsz1x-u29tzerc2-.jpeg"
                 bgimgfield="li_img__1617480849892"
                 style=" background-image: url(/langings/agileEcosystem/images/tild3337-3732-4533-a232-363032663835__-__resizeb__20x__t03txsz1x-u29tzerc2-.jpeg);"></div>
          </div>
          <div class="t525__textwrapper t525__textwr_leftpadding t-cell t-valign_top">
            <div class="t525__text t-text t-text_xs" field="li_text__1617480849892" style=" max-width: 400px;">Great
              product. Already a user of Chpokify since the closed beta version. Really like its <strong>clear and fast
                UI</strong>, <strong>simple way to launch tasks estimation</strong>. Love it.
            </div>
            <div class="t525__title t-name t-name_xs" field="li_title__1617480849892" style=" max-width: 400px;"><a
              href="https://www.linkedin.com/in/disc/" style="" target="_blank" rel="noopener">Alexandr H.</a><br></div>
            <div class="t525__descr t-descr t-descr_xxs" field="li_descr__1617480849892" style=" max-width: 400px;">
              <span style="color: rgb(255, 191, 0);">★★★★★<br></span>CTO at Live Streaming Platform
            </div>
          </div>
        </div>
        <div class="t525__col t-col t-col_6" data-animate-style="fadeinup"
             data-animate-chain="yes">
          <div class="t-cell t-valign_top">
            <div class="t525__bgimg t525__img_circle t-bgimg"
                 data-original="/langings/agileEcosystem/images/tild6632-6363-4431-b231-666431333738__t03txsz1x-u92431saw-.jpeg"
                 bgimgfield="li_img__1617480924239"
                 style=" background-image: url(/langings/agileEcosystem/images/tild6632-6363-4431-b231-666431333738__-__resizeb__20x__t03txsz1x-u92431saw-.jpeg);"></div>
          </div>
          <div class="t525__textwrapper t525__textwr_leftpadding t-cell t-valign_top">
            <div class="t525__text t-text t-text_xs" field="li_text__1617480924239" style=" max-width: 400px;"><strong>Awesome
              experience</strong> with Chpokify. Today we successfully used it for the DevOps team's PBR and really
              enjoyed the tool. Highly recommend it to all development teams.
            </div>
            <div class="t525__title t-name t-name_xs" field="li_title__1617480924239" style=" max-width: 400px;"><a
              href="https://www.linkedin.com/in/kolegova/" style="" target="_blank" rel="noopener">Julia K.</a><br>
            </div>
            <div class="t525__descr t-descr t-descr_xxs" field="li_descr__1617480924239" style=" max-width: 400px;">
              <span style="color: rgb(255, 191, 0);">★★★★★<br></span>Project Manager at Affiliate Platform
            </div>
          </div>
        </div>
      </div>
    </div>
    <style> .t-review-social-links {
      line-height: 0px;
    }

    .t-review-social-links__wrapper {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      width: auto;
    }

    .t-review-social-links {
      margin-top: 15px;
    }

    .t-review-social-links__item {
      padding: 0px 4px;
    }

    .t-review-social-links__item svg {
      width: 20px;
      height: 20px;
    }

    .t-review-social-links__wrapper_round .t-review-social-links__item svg {
      width: 23px;
      height: 23px;
    }

    .t-review-social-links__item:first-child {
      padding-left: 0px;
    }

    @media screen and (max-width: 960px) {
      .t-review-social-links__item {
        margin-bottom: 3px;
      }
    }

    @media screen and (max-width: 640px) {
      .t-review-social-links {
        margin-top: 13px;
      }

      .t-review-social-links__item {
        padding: 0px 3px;
      }

      .t-review-social-links__item svg {
        width: 17px;
        height: 17px;
      }

      .t-review-social-links__wrapper_round .t-review-social-links__item svg {
        width: 20px;
        height: 20px;
      }
    }</style>
    <script type="text/javascript"> function t_reviews_social_init(recid) {
      var rec = $('#rec' + recid);
      var social = rec.find('.t-review-social-links');
      if (social !== 'undefined' && social.length > 0) {
        social.each(function () {
          var $this = $(this);
          var socialAttr = $this.attr('data-social-links');
          var socialWrapper = $this.find('.t-review-social-links__wrapper');
          var links;
          $this.removeAttr('data-social-links');
          if (typeof socialAttr !== 'undefined') {
            links = socialAttr.split(',');
            links.forEach(function (item) {
              t_reviews_social_add_item(item, socialWrapper);
            });
          }
        });
      }
    }

    function t_reviews_social_add_item(item, socialWrapper) {
      var fill = socialWrapper.attr('data-social-color') || '#000000';
      var fb = '';
      fb = '<div class="t-review-social-links__item">';
      fb += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        fb += '<svg class="t-review-social-links__svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 48 48" enable-background="new 0 0 48 48" xml:space="preserve" fill="' + fill + '"><desc>Facebook</desc><path d="M47.761,24c0,13.121-10.638,23.76-23.758,23.76C10.877,47.76,0.239,37.121,0.239,24c0-13.124,10.638-23.76,23.764-23.76C37.123,0.24,47.761,10.876,47.761,24 M20.033,38.85H26.2V24.01h4.163l0.539-5.242H26.2v-3.083c0-1.156,0.769-1.427,1.308-1.427h3.318V9.168L26.258,9.15c-5.072,0-6.225,3.796-6.225,6.224v3.394H17.1v5.242h2.933V38.85z"></path></svg>';
      } else {
        fb += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M21.1 7.8C22.5 6.5 24.5 6 26.4 6h6v6.3h-3.9c-.8-.1-1.6.6-1.8 1.4v4.2h5.7c-.1 2-.4 4.1-.7 6.1h-5v18h-7.4V24h-3.6v-6h3.6v-5.9c.1-1.7.7-3.3 1.8-4.3z"/></svg>';
      }
      fb += '</a>';
      fb += '</div>';
      var twi = '';
      twi += '<div class="t-review-social-links__item">';
      twi += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        twi += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48" fill="' + fill + '"><path d="M47.762 24c0 13.121-10.639 23.76-23.761 23.76S.24 37.121.24 24C.24 10.876 10.879.24 24.001.24S47.762 10.876 47.762 24m-9.731-11.625a12.148 12.148 0 0 1-3.87 1.481 6.08 6.08 0 0 0-4.455-1.926 6.095 6.095 0 0 0-6.093 6.095c0 .478.054.941.156 1.388a17.302 17.302 0 0 1-12.559-6.367 6.066 6.066 0 0 0-.825 3.064 6.088 6.088 0 0 0 2.711 5.07 6.075 6.075 0 0 1-2.761-.762v.077c0 2.951 2.1 5.414 4.889 5.975a6.079 6.079 0 0 1-2.752.106 6.104 6.104 0 0 0 5.692 4.232 12.226 12.226 0 0 1-7.567 2.607c-.492 0-.977-.027-1.453-.084a17.241 17.241 0 0 0 9.34 2.736c11.209 0 17.337-9.283 17.337-17.337 0-.263-.004-.527-.017-.789a12.358 12.358 0 0 0 3.039-3.152 12.138 12.138 0 0 1-3.498.958 6.089 6.089 0 0 0 2.686-3.372"/></svg>';
      } else {
        twi += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M41.8 12.7c-1.3.6-2.8 1-4.2 1.1 1.5-1 2.6-2.3 3.2-4-1.5.8-2.9 1.5-4.7 1.8-1.3-1.5-3.2-2.3-5.3-2.3-4 0-7.3 3.2-7.3 7.3 0 .6 0 1.1.2 1.6-6-.3-11.3-3.2-15.1-7.6-.6 1.1-1 2.3-1 3.7 0 2.6 1.3 4.7 3.2 6-1.1 0-2.3-.3-3.2-1v.2c0 3.6 2.4 6.5 5.8 7.1-.6.2-1.3.3-1.9.3-.5 0-1 0-1.3-.2 1 2.9 3.6 5 6.8 5-2.4 1.9-5.7 3.1-9.1 3.1-.6 0-1.1 0-1.8-.2 3.2 2.1 7 3.2 11.2 3.2 13.4 0 20.7-11 20.7-20.7v-1c1.7-.7 2.8-2 3.8-3.4z"/></svg>';
      }
      twi += '</a>';
      twi += '</div>';
      var vk = '';
      vk += '<div class="t-review-social-links__item">';
      vk += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        vk += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48" fill="' + fill + '"><path d="M47.761 24c0 13.121-10.639 23.76-23.76 23.76C10.878 47.76.239 37.121.239 24 .239 10.877 10.878.24 24.001.24c13.121 0 23.76 10.637 23.76 23.76m-12.502 4.999c-2.621-2.433-2.271-2.041.89-6.25 1.923-2.562 2.696-4.126 2.45-4.796-.227-.639-1.64-.469-1.64-.469l-4.71.029s-.351-.048-.609.106c-.249.151-.414.505-.414.505s-.742 1.982-1.734 3.669c-2.094 3.559-2.935 3.747-3.277 3.524-.796-.516-.597-2.068-.597-3.171 0-3.449.522-4.887-1.02-5.259-.511-.124-.887-.205-2.195-.219-1.678-.016-3.101.007-3.904.398-.536.263-.949.847-.697.88.31.041 1.016.192 1.388.699.484.656.464 2.131.464 2.131s.282 4.056-.646 4.561c-.632.347-1.503-.36-3.37-3.588-.958-1.652-1.68-3.481-1.68-3.481s-.14-.344-.392-.527c-.299-.222-.722-.298-.722-.298l-4.469.018s-.674-.003-.919.289c-.219.259-.018.752-.018.752s3.499 8.104 7.573 12.23c3.638 3.784 7.764 3.36 7.764 3.36h1.867s.566.113.854-.189c.265-.288.256-.646.256-.646s-.034-2.512 1.129-2.883c1.15-.36 2.624 2.429 4.188 3.497 1.182.812 2.079.633 2.079.633l4.181-.056s2.186-.136 1.149-1.858c-.197-.139-.715-1.269-3.219-3.591"/></svg>';
      } else {
        vk += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M41.2 22.2c.6-.8 1.1-1.5 1.5-2 2.7-3.5 3.8-5.8 3.5-6.8l-.2-.2c-.1-.1-.3-.3-.7-.4-.4-.1-.9-.1-1.5-.1h-7.2c-.2 0-.3 0-.3.1 0 0-.1 0-.1.1v.1c-.1 0-.2.1-.3.2-.1.1-.2.2-.2.4-.7 1.9-1.5 3.6-2.5 5.2-.6 1-1.1 1.8-1.6 2.5s-.9 1.2-1.2 1.5c-.3.3-.6.6-.9.8-.2.3-.4.4-.5.4-.1 0-.3-.1-.4-.1-.2-.1-.4-.3-.5-.6-.1-.2-.2-.5-.3-.9 0-.4-.1-.7-.1-.9v-4c0-.7 0-1.2.1-1.6v-1.3c0-.4 0-.8-.1-1.1-.1-.3-.1-.5-.2-.7-.1-.2-.3-.4-.5-.6-.2-.1-.5-.2-.8-.3-.8-.2-1.9-.3-3.1-.3-2.9 0-4.7.2-5.5.6-.3.2-.6.4-.9.7-.3.3-.3.5-.1.6.9.1 1.6.5 2 1l.1.3c.1.2.2.6.3 1.1.1.5.2 1.1.2 1.7.1 1.1.1 2.1 0 2.9-.1.8-.1 1.4-.2 1.9-.1.4-.2.8-.3 1.1-.1.3-.2.4-.3.5 0 .1-.1.1-.1.1-.1-.1-.4-.1-.6-.1-.2 0-.5-.1-.8-.3-.3-.2-.6-.5-1-.9-.3-.4-.7-.9-1.1-1.6-.4-.7-.8-1.5-1.3-2.4l-.4-.7c-.2-.4-.5-1.1-.9-1.9-.4-.8-.8-1.6-1.1-2.4-.1-.3-.3-.6-.6-.7l-.1-.1c-.1-.1-.2-.1-.4-.2s-.3-.1-.5-.2H3.2c-.6 0-1.1.1-1.3.4l-.1.1c0 .1-.1.2-.1.4s0 .4.1.6c.9 2.2 1.9 4.3 3 6.3s2 3.6 2.8 4.9c.8 1.2 1.6 2.4 2.4 3.5.8 1.1 1.4 1.8 1.7 2.1.3.3.5.5.6.7l.6.6c.4.4.9.8 1.6 1.3.7.5 1.5 1 2.4 1.5.9.5 1.9.9 3 1.2 1.2.3 2.3.4 3.4.4H26c.5 0 .9-.2 1.2-.5l.1-.1c.1-.1.1-.2.2-.4s.1-.4.1-.6c0-.7 0-1.3.1-1.8s.2-.9.4-1.2c.1-.3.3-.5.5-.7.2-.2.3-.3.4-.3.1 0 .1-.1.2-.1.4-.1.8 0 1.3.4s1 .8 1.4 1.3c.4.5 1 1.1 1.6 1.8.6.7 1.2 1.2 1.6 1.5l.5.3c.3.2.7.4 1.2.5.5.2.9.2 1.3.1l5.9-.1c.6 0 1-.1 1.4-.3.3-.2.5-.4.6-.6.1-.2.1-.5 0-.8-.1-.3-.1-.5-.2-.6-.1-.1-.1-.2-.2-.3-.8-1.4-2.2-3.1-4.4-5.1-1-.9-1.6-1.6-1.9-1.9-.5-.6-.6-1.2-.3-1.9.3-.5 1-1.5 2.2-3z"/></svg>';
      }
      vk += '</a>';
      vk += '</div>';
      var ok = '';
      ok += '<div class="t-review-social-links__item">';
      ok += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        ok += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="' + fill + '"><path d="M15.001 29.997C6.715 29.997 0 23.28 0 14.997 0 6.714 6.715 0 15.001 0 23.282-.001 30 6.713 30 14.998c0 8.283-6.716 14.999-14.998 14.999zM15 9.163c.986 0 1.787.803 1.787 1.787 0 .987-.801 1.788-1.787 1.788a1.788 1.788 0 0 1 0-3.574zm4.317 1.787a4.322 4.322 0 0 0-4.317-4.319 4.323 4.323 0 0 0-4.319 4.32A4.322 4.322 0 0 0 15 15.266a4.32 4.32 0 0 0 4.316-4.317zm-2.57 7.84a8.126 8.126 0 0 0 2.507-1.038 1.266 1.266 0 0 0-1.347-2.143 5.482 5.482 0 0 1-5.816 0 1.265 1.265 0 0 0-1.348 2.143c.78.49 1.628.838 2.507 1.038l-2.414 2.414a1.267 1.267 0 0 0 .894 2.16c.324 0 .649-.125.895-.37l2.371-2.373 2.373 2.373a1.265 1.265 0 0 0 1.788-1.789l-2.41-2.415z"/></svg>';
      } else {
        ok += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="' + fill + '"><path d="M12.498 6.2a1.932 1.932 0 0 0-1.929 1.93 1.932 1.932 0 0 0 3.861 0 1.932 1.932 0 0 0-1.932-1.93zm0 6.592a4.668 4.668 0 0 1-4.66-4.662 4.665 4.665 0 0 1 4.66-4.663 4.666 4.666 0 0 1 4.664 4.663 4.669 4.669 0 0 1-4.664 4.662zm-1.884 3.801a8.75 8.75 0 0 1-2.708-1.12 1.367 1.367 0 1 1 1.455-2.312 5.925 5.925 0 0 0 6.276 0 1.367 1.367 0 1 1 1.456 2.311c-.832.522-1.749.9-2.707 1.12l2.606 2.608a1.367 1.367 0 0 1-1.933 1.931L12.5 18.569l-2.561 2.562a1.368 1.368 0 0 1-1.934-1.934l2.609-2.604z"/></svg>';
      }
      ok += '</a>';
      ok += '</div>';
      var behance = '';
      behance += '<div class="t-review-social-links__item">';
      behance += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        behance += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="-455 257 48 48" fill="' + fill + '"><path d="M-421.541 278.608c-3.095 0-3.526 3.09-3.526 3.09h6.581c0-.001.042-3.09-3.055-3.09zM-436.472 281.697h-5.834v5.356h5.165c.088 0 .219.002.374 0 .831-.02 2.406-.261 2.406-2.604-.001-2.78-2.111-2.752-2.111-2.752z"/><path d="M-430.984 257C-444.248 257-455 267.75-455 281.014c0 13.263 10.752 24.016 24.016 24.016 13.262 0 24.014-10.752 24.014-24.016-.001-13.263-10.754-24.014-24.014-24.014zm5.054 14.756h8.267v2.467h-8.267v-2.467zm-4.179 12.943c0 6.116-6.364 5.914-6.364 5.914h-10.428v-20.038h10.428c3.168 0 5.668 1.75 5.668 5.335s-3.057 3.813-3.057 3.813c4.031 0 3.753 4.976 3.753 4.976zm15.466-.328h-10.384c0 3.722 3.526 3.487 3.526 3.487 3.329 0 3.213-2.156 3.213-2.156h3.527c0 5.722-6.859 5.33-6.859 5.33-8.227 0-7.698-7.661-7.698-7.661s-.008-7.698 7.698-7.698c8.112.001 6.977 8.698 6.977 8.698z"/><path d="M-435.055 276.221c0-2.084-1.417-2.084-1.417-2.084H-442.306v4.471h5.472c.944 0 1.779-.304 1.779-2.387z"/></svg>';
      } else {
        behance += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="' + fill + '"><path d="M22.4 7.5h-5.6V6.1h5.6v1.4zm-9.3 5.7c.4.6.5 1.2.5 2s-.2 1.6-.6 2.2c-.3.4-.6.8-1 1.1-.4.3-1 .6-1.6.7-.6.1-1.3.2-2 .2H2.3V5.6H9c1.7 0 2.9.5 3.6 1.5.4.6.6 1.3.6 2.1s-.2 1.5-.6 2c-.2.3-.6.6-1.1.8.7.2 1.2.7 1.6 1.2zM5.5 11h2.9c.6 0 1.1-.1 1.5-.3.4-.2.6-.6.6-1.2s-.2-1.1-.7-1.3C9.3 8.1 8.7 8 8.1 8H5.5v3zm5.2 4c0-.7-.3-1.2-.9-1.5-.3-.2-.8-.2-1.4-.2h-3V17h2.9c.6 0 1.1-.1 1.4-.2.7-.3 1-.9 1-1.8zm13.8-2.2c.1.5.1 1.1.1 2h-7.2c0 1 .4 1.7 1 2.1.4.3.9.4 1.4.4.6 0 1.1-.1 1.4-.5.2-.2.4-.4.5-.7h2.6c-.1.6-.4 1.2-1 1.8-.9 1-2.1 1.4-3.7 1.4-1.3 0-2.5-.4-3.5-1.2-1-.8-1.5-2.1-1.5-4 0-1.7.5-3 1.4-4 .9-.9 2.1-1.4 3.5-1.4.9 0 1.6.2 2.3.5.7.3 1.3.8 1.7 1.5.6.6.8 1.3 1 2.1zm-2.7.2c0-.7-.3-1.2-.7-1.6-.4-.4-.9-.5-1.5-.5-.7 0-1.2.2-1.5.6-.4.4-.6.9-.7 1.5h4.4z"/></svg>';
      }
      behance += '</a>';
      behance += '</div>';
      var vimeo = '';
      vimeo += '<div class="t-review-social-links__item">';
      vimeo += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        vimeo += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="-455 257 48 48" fill="' + fill + '"><path d="M-431 256.971c13.267 0 24.023 10.755 24.023 24.023s-10.755 24.023-24.023 24.023-24.023-10.755-24.023-24.023 10.756-24.023 24.023-24.023zm-12.262 19.146l.996 1.306s2.054-1.619 2.739-.81c.685.81 3.299 10.584 4.171 12.387.761 1.581 2.862 3.672 5.166 2.179 2.302-1.493 9.959-8.03 11.329-15.749 1.369-7.717-9.213-6.1-10.335.623 2.802-1.682 4.297.683 2.863 3.362-1.431 2.676-2.739 4.421-3.424 4.421-.683 0-1.209-1.791-1.992-4.92-.81-3.236-.804-9.064-4.17-8.403-3.171.623-7.343 5.604-7.343 5.604z"/></svg>';
      } else {
        vimeo += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M2.9 16.5l1.6 2s3.2-2.5 4.3-1.3c1.1 1.3 5.2 16.5 6.5 19.3 1.2 2.5 4.5 5.7 8.1 3.4S39 27.4 41.1 15.3s-14.4-9.5-16.1 1c4.4-2.6 6.7 1.1 4.5 5.3s-4.3 6.9-5.3 6.9c-1.1 0-1.9-2.8-3.1-7.7-1.3-5.1-1.3-14.2-6.5-13.1-5.2 1-11.7 8.8-11.7 8.8z"/></svg>';
      }
      vimeo += '</a>';
      vimeo += '</div>';
      var youtube = '';
      youtube += '<div class="t-review-social-links__item">';
      youtube += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        youtube += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="-455 257 48 48" fill="' + fill + '"><path d="M-431 257.013c13.248 0 23.987 10.74 23.987 23.987s-10.74 23.987-23.987 23.987-23.987-10.74-23.987-23.987 10.739-23.987 23.987-23.987zm11.815 18.08c-.25-1.337-1.363-2.335-2.642-2.458-3.054-.196-6.119-.355-9.178-.357-3.059-.002-6.113.154-9.167.347-1.284.124-2.397 1.117-2.646 2.459a40.163 40.163 0 0 0 0 11.672c.249 1.342 1.362 2.454 2.646 2.577 3.055.193 6.107.39 9.167.39 3.058 0 6.126-.172 9.178-.37 1.279-.124 2.392-1.269 2.642-2.606a39.769 39.769 0 0 0 0-11.654zm-14.591 9.342v-7.115l6.627 3.558-6.627 3.557z"/></svg>';
      } else {
        youtube += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M43.9 15.3c-.4-3.1-2.2-5-5.3-5.3-3.6-.3-11.4-.5-15-.5-7.3 0-10.6.2-14.1.5-3.3.3-4.8 1.8-5.4 4.9-.4 2.1-.6 4.1-.6 8.9 0 4.3.2 6.9.5 9.2.4 3.1 2.5 4.8 5.7 5.1 3.6.3 10.9.5 14.4.5s11.2-.2 14.7-.6c3.1-.4 4.6-2 5.1-5.1 0 0 .5-3.3.5-9.1 0-3.3-.2-6.4-.5-8.5zM19.7 29.8V18l11.2 5.8-11.2 6z"/></svg>';
      }
      youtube += '</a>';
      youtube += '</div>';
      var instagram = '';
      instagram += '<div class="t-review-social-links__item">';
      instagram += ' <a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        instagram += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="' + fill + '"><path d="M15 11.014a3.986 3.986 0 1 0 .001 7.971A3.986 3.986 0 0 0 15 11.014zm0 6.592A2.604 2.604 0 0 1 12.393 15 2.604 2.604 0 0 1 15 12.394 2.614 2.614 0 0 1 17.607 15 2.604 2.604 0 0 1 15 17.606zM19.385 9.556a.915.915 0 0 0-.92.921c0 .512.407.919.92.919a.914.914 0 0 0 .921-.919.916.916 0 0 0-.921-.921z"/><path d="M15.002.15C6.798.15.149 6.797.149 15c0 8.201 6.649 14.85 14.853 14.85 8.199 0 14.85-6.648 14.85-14.85 0-8.203-6.651-14.85-14.85-14.85zm7.664 18.115c0 2.423-1.979 4.401-4.416 4.401h-6.5c-2.438 0-4.417-1.979-4.417-4.386v-6.546c0-2.422 1.978-4.4 4.417-4.4h6.5c2.438 0 4.416 1.978 4.416 4.4v6.531z"/></svg>';
      } else {
        instagram += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="' + fill + '"><path d="M16.396 3.312H8.604c-2.921 0-5.292 2.371-5.292 5.273v7.846c0 2.886 2.371 5.256 5.292 5.256h7.791c2.922 0 5.292-2.37 5.292-5.274V8.586c.001-2.903-2.37-5.274-5.291-5.274zM7.722 12.5a4.778 4.778 0 1 1 9.554 0 4.778 4.778 0 0 1-9.554 0zm10.034-4.318c-.615 0-1.104-.487-1.104-1.102s.488-1.103 1.104-1.103c.614 0 1.102.488 1.102 1.103s-.488 1.102-1.102 1.102z" /><path d="M12.5 9.376A3.12 3.12 0 0 0 9.376 12.5a3.12 3.12 0 0 0 3.124 3.124 3.12 3.12 0 0 0 3.124-3.124A3.133 3.133 0 0 0 12.5 9.376z"/></svg>';
      }
      instagram += '</a>';
      instagram += '</div>';
      var pinterest = '';
      pinterest += '<div class="t-review-social-links__item">';
      pinterest += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        pinterest += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="-455 257 48 48" fill="' + fill + '"><path d="M-407 281c0 13.254-10.746 24-23.999 24-13.257 0-24.003-10.746-24.003-24 0-13.256 10.746-24 24.003-24 13.253 0 23.999 10.744 23.999 24zm-30.628 14.811c.027.205.29.254.409.1.17-.223 2.365-2.932 3.111-5.639.211-.768 1.212-4.738 1.212-4.738.599 1.145 2.349 2.148 4.21 2.148 5.539 0 9.297-5.049 9.297-11.809 0-5.111-4.329-9.873-10.909-9.873-8.186 0-12.314 5.871-12.314 10.766 0 2.963 1.122 5.6 3.527 6.582.395.162.749.006.863-.43.08-.303.268-1.065.353-1.385.114-.432.07-.582-.248-.959-.694-.818-1.138-1.879-1.138-3.381 0-4.353 3.259-8.252 8.484-8.252 4.627 0 7.169 2.828 7.169 6.603 0 4.969-2.198 9.162-5.461 9.162-1.804 0-3.153-1.49-2.722-3.32.518-2.182 1.522-4.537 1.522-6.113 0-1.41-.758-2.588-2.324-2.588-1.843 0-3.323 1.908-3.323 4.461 0 1.627.55 2.727.55 2.727l-2.217 9.391c-.657 2.787-.099 6.203-.051 6.547z"/></svg>';
      } else {
        pinterest += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M24.9 5.5c4.2 0 7.7 1.3 10.5 3.9s4.1 5.7 4.1 9.2c0 4.6-1.2 8.4-3.5 11.3-2.3 3-5.3 4.5-8.9 4.5-1.2 0-2.3-.3-3.4-.9s-1.8-1.3-2.2-2c-.9 3.5-1.4 5.6-1.6 6.3-.7 2.4-2 4.9-4.1 7.5-.2.2-.4.2-.5-.1-.5-3.5-.5-6.4.1-8.7l2.9-12.6c-.5-.9-.7-2.1-.7-3.6 0-1.7.4-3.1 1.3-4.2s1.9-1.7 3.2-1.7c1 0 1.8.3 2.3 1 .5.6.8 1.5.8 2.4 0 .6-.1 1.4-.3 2.3-.2.9-.5 1.9-.9 3.1s-.6 2.1-.8 2.8c-.3 1.2-.1 2.2.7 3.1.7.9 1.7 1.3 3 1.3 2.1 0 3.8-1.2 5.2-3.6 1.4-2.4 2-5.3 2-8.7 0-2.6-.8-4.7-2.5-6.3-1.7-1.6-4-2.4-7-2.4-3.4 0-6.1 1.1-8.2 3.2S13 17.4 13 20.4c0 1.8.5 3.3 1.5 4.5.3.4.4.8.3 1.2 0 .1-.1.3-.2.6-.1.4-.1.6-.2.7 0 .1-.1.4-.2.6-.1.3-.3.4-.4.4h-.6c-3.1-1.3-4.7-4.2-4.7-8.7 0-3.6 1.5-6.9 4.4-9.9s7-4.3 12-4.3z"/></svg>';
      }
      pinterest += '</a>';
      pinterest += '</div>';
      var linkedin = '';
      linkedin += '<div class="t-review-social-links__item">';
      linkedin += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        linkedin += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="-615 1477 48 48" fill="' + fill + '"><path d="M-566.999 1501c0 13.256-10.746 24-24 24-13.256 0-24.002-10.744-24.002-24 0-13.254 10.746-24 24.002-24 13.254 0 24 10.746 24 24zm-38.507 13.975h6.22v-20.004h-6.22v20.004zm3.11-22.739a3.606 3.606 0 0 0 0-7.211 3.603 3.603 0 0 0-3.604 3.605 3.604 3.604 0 0 0 3.604 3.606zm26.396 11.766c0-5.387-1.163-9.529-7.454-9.529-3.023 0-5.054 1.658-5.884 3.231h-.085v-2.733h-5.964v20.004h6.216v-9.896c0-2.609.493-5.137 3.729-5.137 3.186 0 3.232 2.984 3.232 5.305v9.729h6.21v-10.974z"/></svg>';
      } else {
        linkedin += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M42.3 23.1v13.5h-7.9V24c0-3.2-1.1-5.3-4-5.3-2.2 0-3.5 1.5-4 2.9-.2.5-.3 1.2-.3 1.9v13.2h-7.9s.1-21.4 0-23.6h7.9v3.3s0 .1-.1.1h.1v-.1c1-1.6 2.9-3.9 7.1-3.9 5.2-.1 9.1 3.3 9.1 10.6zM10.1 1.6c-2.7 0-4.4 1.8-4.4 4.1S7.4 9.8 10 9.8h.1c2.7 0 4.4-1.8 4.4-4.1s-1.7-4.1-4.4-4.1zm-3.9 35H14V13H6.2v23.6z"/></svg>';
      }
      linkedin += '</a>';
      linkedin += '</div>';
      var soundcloud = '';
      soundcloud += '<div class="t-review-social-links__item">';
      soundcloud += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        soundcloud += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 48 48" fill="' + fill + '"><defs><path id="a" d="M0 0h48v48H0V0z"/></defs><g fill-rule="evenodd"><path d="M38.206 22.171c-.635 0-1.241.129-1.793.36-.369-4.177-3.871-7.453-8.144-7.453a8.28 8.28 0 0 0-2.965.553c-.35.136-.442.275-.446.546v14.709a.545.545 0 0 0 .5.531c.013.002 12.848 0 12.848 0 2.56 0 4.634-2.051 4.634-4.611a4.634 4.634 0 0 0-4.634-4.635zM24.17 16.237a.5.5 0 0 0-.582.043.517.517 0 0 0-.189.392v.053l-.21 10.388.107 1.92.103 1.869a.514.514 0 0 0 .51.505.515.515 0 0 0 .51-.509v.004l.228-3.79-.227-10.44a.517.517 0 0 0-.25-.435zm-1.364 14.72v-.001.001-.002.002zm-.215-13.813a.47.47 0 0 0-.264-.081.486.486 0 0 0-.478.477l-.001.09-.18 9.48.181 3.847.001.016a.48.48 0 0 0 .477.458c.246 0 .248-.054.335-.14a.486.486 0 0 0 .144-.336l.02-.38.181-3.463-.201-9.573a.487.487 0 0 0-.215-.395zm-1.853 1.479a.447.447 0 0 0-.446.444l-.2 8.044.2 3.87c.005.465.2.442.446.442.245 0 .44.023.446-.444v.003l.223-3.87-.223-8.046a.447.447 0 0 0-.446-.443zm-1.577-.273a.416.416 0 0 0-.414.412l-.219 8.349.219 3.895c.005.228.187.41.414.41a.416.416 0 0 0 .413-.412v.002l.246-3.895-.246-8.35a.416.416 0 0 0-.413-.411zm-1.184 12.693v-.002.002zm0-12.5a.385.385 0 0 0-.382-.38.384.384 0 0 0-.381.38l-.238 8.567.238 3.932c.006.21.173.377.381.377a.385.385 0 0 0 .382-.378l.268-3.931-.268-8.568zm-1.935-.069a.354.354 0 0 0-.35.347l-.256 8.288.257 3.957c.006.193.16.346.35.346a.354.354 0 0 0 .349-.347v.002l.29-3.958-.29-8.288a.355.355 0 0 0-.35-.347zm-1.564.691a.322.322 0 0 0-.318.315l-.275 7.65.276 3.998a.321.321 0 0 0 .317.313c.17 0 .31-.138.317-.315v.002l.312-3.999-.312-7.65a.323.323 0 0 0-.317-.314zM12.974 20.6a.29.29 0 0 0-.285.282l-.295 6.226.295 4.023a.29.29 0 0 0 .285.281.292.292 0 0 0 .285-.282v.001l.333-4.023-.333-6.226a.292.292 0 0 0-.285-.282zm-1.264 2.678a.258.258 0 0 0-.253-.248.257.257 0 0 0-.253.25l-.314 3.826.314 4.024c.008.142.117.25.253.25a.259.259 0 0 0 .253-.25l.356-4.024-.356-3.828zm0 7.851v.001zm-1.757-8.366a.226.226 0 0 0-.221.217l-.333 4.126.333 3.99c.009.124.104.217.22.217s.21-.093.221-.216l.4-3.991-.4-4.126c-.01-.123-.105-.217-.22-.217zm-1.493.142c-.1 0-.179.078-.189.185l-.351 4.015.351 3.868c.01.108.09.185.19.185.097 0 .176-.077.188-.184l.4-3.869-.4-4.015c-.012-.107-.091-.185-.189-.185zm-2.873 1.96c-.079 0-.14.06-.151.147l-.276 2.094.276 2.056c.01.086.072.147.15.147s.14-.06.152-.147l.326-2.056-.326-2.095c-.013-.086-.074-.145-.151-.145zM6.98 23.57c-.08 0-.146.064-.157.152l-.25 3.385.25 3.308c.011.088.077.152.157.152s.144-.062.156-.152l.422-3.308-.422-3.385c-.012-.09-.077-.152-.156-.152zM48 24c0 13.255-10.745 24-24 24C10.757 48 0 37.255 0 24 0 10.757 10.757 0 24 0c13.255 0 24 10.757 24 24z"/></g></svg>';
      } else {
        soundcloud += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48" fill="' + fill + '"><path d="M1.6 24.3c-.2 0-.3.1-.3.3l-.5 6.2.5 6c0 .2.2.3.3.3.2 0 .3-.1.3-.3l.6-6-.6-6.2c0-.2-.1-.3-.3-.3zm3.3 12.6zm0-11.8c0-.2-.2-.4-.4-.4s-.4.2-.4.4l-.5 5.8.5 6.1c0 .2.2.4.4.4s.4-.2.4-.4l.5-6.1-.5-5.8zm2.7-6.2c-.3 0-.5.2-.5.5l-.4 11.5.4 6c0 .3.2.5.5.5s.5-.2.5-.5l.5-6-.5-11.6c-.1-.2-.3-.4-.5-.4zm3.8-1c0-.3-.3-.6-.6-.6s-.6.3-.6.6l-.4 13 .4 5.9c0 .3.3.6.6.6s.6-.3.6-.6l.4-5.9-.4-13zm2.7.1c-.4 0-.7.3-.7.7l-.3 12.2.3 5.9c0 .4.3.7.7.7.4 0 .7-.3.7-.7l.3-5.9-.3-12.2c0-.4-.3-.7-.7-.7zm3.7-3.6c-.1-.1-.3-.1-.4-.1-.2 0-.4.1-.5.2-.2.1-.3.4-.3.6v.1l-.3 15.7.2 2.9.2 2.8c0 .4.4.8.8.8s.8-.3.8-.8l.3-5.7-.3-15.8c-.1-.3-.3-.5-.5-.7zm22.4 9c-1 0-1.9.2-2.7.5-.6-6.3-5.9-11.3-12.3-11.3-1.6 0-3.1.3-4.5.8-.5.2-.7.4-.7.8v22.2c0 .4.3.8.8.8h19.4c3.9 0 7-3.1 7-7 0-3.7-3.1-6.8-7-6.8z"/></svg>';
      }
      soundcloud += '</a>';
      soundcloud += ' </div>';
      var telegram = '';
      telegram += '<div class="t-review-social-links__item">';
      telegram += '<a href="' + item + '" target="_blank">';
      if (socialWrapper.hasClass('t-review-social-links__wrapper_round')) {
        telegram += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 60 60" fill="' + fill + '"><path d="M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zm16.9 13.9l-6.7 31.5c-.1.6-.8.9-1.4.6l-10.3-6.9-5.5 5.2c-.5.4-1.2.2-1.4-.4L18 32.7l-9.5-3.9c-.7-.3-.7-1.5 0-1.8l37.1-14.1c.7-.2 1.4.3 1.3 1z"/><path d="M22.7 40.6l.6-5.8 16.8-16.3-20.2 13.3"/></svg>';
      } else {
        telegram += '<svg class="t-review-social-links__svg" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 60 60" fill="' + fill + '"><path d="M52.5 9L6.1 26.9c-.9.4-.9 1.8 0 2.3L18 34.1l4.4 14.1c.3.8 1.2 1 1.8.5l6.8-6.4L43.9 51c.7.4 1.6 0 1.7-.7l8.4-40c.2-.8-.7-1.6-1.5-1.3zm-28 27.7l-.7 7.3-3.6-11.2L45.5 16l-21 20.7z"/></svg>';
      }
      telegram += '</a>';
      telegram += '</div>';
      if (item.indexOf('facebook') != -1) {
        socialWrapper.append(fb);
      }
      if (item.indexOf('twitter') != -1) {
        socialWrapper.append(twi);
      }
      if (item.indexOf('vk.com') != -1) {
        socialWrapper.append(vk);
      }
      if (item.indexOf('ok.ru') != -1) {
        socialWrapper.append(ok);
      }
      if (item.indexOf('behance') != -1) {
        socialWrapper.append(behance);
      }
      if (item.indexOf('vimeo') != -1) {
        socialWrapper.append(vimeo);
      }
      if (item.indexOf('youtube') != -1) {
        socialWrapper.append(youtube);
      }
      if (item.indexOf('instagram') != -1) {
        socialWrapper.append(instagram);
      }
      if (item.indexOf('pinterest') != -1) {
        socialWrapper.append(pinterest);
      }
      if (item.indexOf('linkedin') != -1) {
        socialWrapper.append(linkedin);
      }
      if (item.indexOf('soundcloud') != -1) {
        socialWrapper.append(soundcloud);
      }
      if (item.indexOf('telegram') != -1) {
        socialWrapper.append(telegram);
      }
    }</script>
    <script type="text/javascript"> $(document)
      .ready(function () {
        t_reviews_social_init('384566820');
      });</script>
    <style>@media screen and (max-width: 640px) {
      .t525 .t-review-social-links__wrapper {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
      }
    }</style>
  </div>
  <div id="rec376536720" class="r t-rec t-rec_pt_90 t-rec_pb_0"
       style="padding-top:90px;padding-bottom:0px;background-color:#f4fbfe; " data-record-type="255"
       data-bg-color="#f4fbfe" data-animationappear="off">
    <div class="t225">
      <div class="t-container t-align_center">
        <div class="t-col t-col_8 t-prefix_2">
          <div class="t225__uptitle t-uptitle t-uptitle_sm" field="subtitle"
               style="color:#9147ff;padding-bottom:10px;text-transform:uppercase;">New level of security
          </div>
          <div class="t225__title t-title t-title_md" field="title" style="">
            <div style="font-size:42px;" data-customstyle="yes">4 Reasons Why You Can <br>Sleep Tight</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec376539635" class="r t-rec t-rec_pt_75 t-rec_pb_75"
       style="padding-top:75px;padding-bottom:75px;background-color:#f4fbfe; " data-record-type="499"
       data-bg-color="#f4fbfe" data-animationappear="off">
    <div class="t499">
      <div class="t499__container t-container">
        <div class="t499__col t-col t-col_6 t-item"><img
          src="/langings/agileEcosystem/images/tild6135-3262-4536-a636-333432343537__shield.webp"
          data-original="/langings/agileEcosystem/images/tild6135-3262-4536-a636-333432343537__shield.webp" class="t499__img t-img"
          imgfield="li_img__1476970706605">
          <div class="t499__title t-name t-name_xl" style="padding-top:0px;" field="li_title__1476970706605">Heavily
            encrypted
          </div>
          <div class="t499__blockdescr t-descr t-descr_xs" style="" field="li_descr__1476970706605">Encrypting data is
            the best way to ensure that your data is safe. All data stored by us is encrypted with AES-256 encryption, a
            military-grade cipher that cannot be cracked by any currently known or future technology.
          </div>
        </div>
        <div class="t499__col t-col t-col_6 t-item"><img
          src="/langings/agileEcosystem/images/tild3434-3738-4138-b935-636538366532__password.webp"
          data-original="/langings/agileEcosystem/images/tild3434-3738-4138-b935-636538366532__password.webp" class="t499__img t-img"
          imgfield="li_img__1476970709971">
          <div class="t499__title t-name t-name_xl" style="padding-top:0px;" field="li_title__1476970709971">Only you
            have access to your data
          </div>
          <div class="t499__blockdescr t-descr t-descr_xs" style="" field="li_descr__1476970709971">We take your privacy
            very seriously. After encrypting your data we store it on our servers for you. Our servers are not
            accessible to anyone - even us! (we're nice like that).
          </div>
        </div>
        <div class="t-clear t499__separator" style=""></div>
        <div class="t499__col t-col t-col_6 t-item"><img
          src="/langings/agileEcosystem/images/tild3264-3865-4132-b635-636566343039__incognito.webp"
          data-original="/langings/agileEcosystem/images/tild3264-3865-4132-b635-636566343039__incognito.webp" class="t499__img t-img"
          imgfield="li_img__1476970720067">
          <div class="t499__title t-name t-name_xl" style="padding-top:0px;" field="li_title__1476970720067">Do not
            track anything
          </div>
          <div class="t499__blockdescr t-descr t-descr_xs" style="" field="li_descr__1476970720067">For added security,
            we don't even keep any logs of IP addresses or other browsing information for more than an hour after
            someone has visited the site. All personal data is deleted within 60 minutes after the last usage.
          </div>
        </div>
        <div class="t499__col t-col t-col_6 t-item"><img
          src="/langings/agileEcosystem/images/tild3432-3433-4464-b164-343064356563__code.webp"
          data-original="/langings/agileEcosystem/images/tild3432-3433-4464-b164-343064356563__code.webp" class="t499__img t-img"
          imgfield="li_img__1476970723554">
          <div class="t499__title t-name t-name_xl" style="padding-top:0px;" field="li_title__1476970723554">Open and
            audited source code
          </div>
          <div class="t499__blockdescr t-descr t-descr_xs" style="" field="li_descr__1476970723554">Anyone can view,
            change, and check it. This makes it easier to spot security flaws that might compromise your right to
            privacy. Our source code is regularly audited and reviewed by the community and our developers.
          </div>
        </div>
      </div>
      <div class="t-section__container t-container">
        <div class="t-col t-col_12">
          <div class="t-section__bottomwrapper t-clear t-align_center "><a href="https://chpokify.com/sign-up" target=""
                                                                           class="t-btn"
                                                                           style="color:#ffffff;background-color:#9147ff;border-radius:30px; -moz-border-radius:30px; -webkit-border-radius:30px;">
            <table style="width:100%; height:100%;">
              <tbody>
              <tr>
                <td>Try Now for Free</td>
              </tr>
              </tbody>
            </table>
          </a></div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec380489772" class="r t-rec t-rec_pt_90 t-rec_pb_45"
       style="padding-top:90px;padding-bottom:45px;background-color:#ffffff; " data-record-type="795"
       data-bg-color="#ffffff" data-animationappear="off">
    <div class="t795">
      <div class="t-container t-align_center">
        <div class="t-col t-col_10 t-prefix_1">
          <div class="t795__title t-title t-title_xs t-margin_auto" field="title" style="">Integrations</div>
          <div class="t795__descr t-descr t-descr_xl t-margin_auto" field="descr" style="">Easily sync data with your
            existing applications:<br>Jira, Slack, Trello, GitHub, GitLab, Azure, and others
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="rec380588141" class="r t-rec t-rec_pt_0 t-rec_pb_135"
       style="padding-top:0px;padding-bottom:135px;background-color:#ffffff; " data-record-type="3"
       data-bg-color="#ffffff" data-animationappear="off">
    <div class="t107">
      <div class="t-align_center" itemscope="" itemtype="http://schema.org/ImageObject">
        <meta itemprop="image" content="/langings/agileEcosystem/images/tild3662-3239-4464-b333-343665366165__logos.svg">
        <img
          src="/langings/agileEcosystem/images/tild3662-3239-4464-b333-343665366165__logos.svg"
          class="t107__widthauto t-img" imgfield="img"></div>
    </div>
  </div>
</div>
<div class="t-zoomer__wrapper">
  <div class="t-zoomer__container"></div>
  <div class="t-zoomer__bg"></div>
  <div class="t-zoomer__close" style="display:none;">
    <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.41421 -0.000151038L0 1.41406L21.2132 22.6273L22.6274 21.2131L1.41421 -0.000151038Z"
            fill="black"></path>
      <path d="M22.6291 1.41421L21.2148 0L0.00164068 21.2132L1.41585 22.6274L22.6291 1.41421Z" fill="black"></path>
    </svg>
  </div>
  <div class="t-zoomer__scale showed" style="display:none;">
    <svg class="icon-increase" width="20" height="20" viewBox="0 0 25 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M22.832 22L17.8592 17.0273" stroke="black" stroke-width="2" stroke-linecap="square"></path>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.58591 3.7511C0.917768 7.41924 0.917768 13.367 4.58591 17.0352C8.25405 20.7033 14.2019 20.7033 17.87 17.0352C21.5381 13.367 21.5381 7.41924 17.87 3.7511C14.2019 0.0829653 8.25405 0.0829653 4.58591 3.7511Z"
            stroke="black" stroke-width="2"></path>
      <path d="M6.25781 10.3931H16.2035" stroke="black" stroke-width="2"></path>
      <path d="M11.2305 15.3662V5.42053" stroke="black" stroke-width="2"></path>
    </svg>
    <svg class="icon-decrease" width="20" height="20" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M21.9961 22L17.0233 17.0273" stroke="black" stroke-width="2" stroke-linecap="square"></path>
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M3.74997 3.7511C0.0818308 7.41924 0.0818308 13.367 3.74997 17.0352C7.41811 20.7033 13.3659 20.7033 17.0341 17.0352C20.7022 13.367 20.7022 7.41924 17.0341 3.7511C13.3659 0.0829653 7.41811 0.0829653 3.74997 3.7511Z"
            stroke="black" stroke-width="2"></path>
      <path d="M5.41797 10.3931H15.3637" stroke="black" stroke-width="2"></path>
    </svg>
  </div>
</div>
`
